<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-tabs v-model="activeName2"
             type="card"
             @tab-click="handleClick">
      <!-- 当前版本 -->
      <el-tab-pane :label="$t('user.currentversion')"
                   name="first">
        <div v-show="headDateShow"
             class="headDate">
          {{headDate}}
        </div>
        <el-form label-position="top"
                 :inline="true"
                 :model="dataForm"
                 ref="dataForm"
                 :rules="dataRule">
          <!-- 基本信息 -->
          <div class="opten-title">
            <em class="el-icon-caret-right"></em>{{$t('organization.basicInformation')}}</div>
          <div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 证件类型 -->
                <el-form-item :label="$t('user.idtype')"
                              prop="idType">
                  <el-select v-model="dataForm.idType"
                             @change="idTypeChange(dataForm.idType)"
                             clearable
                             :disabled="editDisable || leaveAndJoinDisabled"
                             :placeholder="$t('user.idtypePlaceholder')">
                    <el-option v-for="(item,index) in idTypeList"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 证件编号 -->
                <el-form-item :label="$t('user.passportIdcard')"
                              prop="idcard">
                  <el-input v-model="dataForm.idcard"
                            :placeholder="$t('user.passportIdcardPlaceholder')"
                            :disabled="editDisable || (dataForm.idType === '' || !dataForm.idType) || leaveAndJoinDisabled"
                            @blur="idCard(dataForm.idcard)"
                            @input="strFormat($event,'idcard')"
                            maxlength="18"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 出生日期 -->
                <el-form-item :label="$t('user.dateofbirth')"
                              prop="birthday">
                  <el-date-picker v-model="dataForm.birthday"
                                  type="date"
                                  :disabled="editDisable || (dataForm.idType === '10' || dataForm.idType === '' || !dataForm.idType) || leaveAndJoinDisabled"
                                  :placeholder="placeBirthday"
                                  :editable='false'
                                  :readonly='readOnly'
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 性别 -->
                <el-form-item :label="$t('user.gender')"
                              prop="sexCode">
                  <el-select v-model="dataForm.sexCode"
                             clearable
                             :placeholder="placeSex"
                             :disabled="dataForm.idType === '10' || dataForm.idType === '' || !dataForm.idType || leaveAndJoinDisabled || !jobabled">
                    <el-option v-for="(item,index) in sexCode"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
			  <el-col :span="6">
                <!-- 姓名 -->
                <el-form-item :label="$t('user.name')"
                              prop="userName">
                  <el-input v-model="dataForm.userName"
                            :disabled="editDisable || leaveAndJoinDisabled"
							              @blur="converToPinyin($event)"
                            :placeholder="$t('user.userNamePlaceholder')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 姓的拼音 -->
                <el-form-item :label="$t('user.firstname')"
                              prop="lastName">
                  <el-input v-model="dataForm.lastName"
                            :disabled="editDisable || leaveAndJoinDisabled"
                            @input="strFormat($event,'lastName')"
                            :placeholder="$t('user.firstNamePlaceholder')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 名的拼音 -->
                <el-form-item :label="$t('user.lastname')"
                              prop="firstName">
                  <el-input v-model="dataForm.firstName"
                            :disabled="editDisable || leaveAndJoinDisabled"
                            @input="strFormat($event,'firstName')"
                            :placeholder="$t('user.lastNamePlaceholder')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 最高学历 -->
                <el-form-item :label="$t('user.education')"
                              prop="educationCode">
                  <el-select v-model="dataForm.educationCode"
                             :disabled="agreePolicyDisable"
                             :placeholder="$t('user.educationCodePlaceholder')">
                    <el-option v-for="(item,index) in educationCode"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 账号信息 -->
          <div>
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{ $t('user.accountinformation') }}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <div class="img-div"
                     @click="modifyImg">
                  <img alt="" :src="dataForm.headurl" />
                  <div class="modify-img"
                       v-show="headModifyShow">
                    {{$t('user.userImg')}}
                  </div>
                </div>
              </el-col>
              <el-col :span="18">
                <el-row class="row-mar-l">
                  <el-col :span="8">
                    <!-- 用户id -->
                    <el-form-item :label="$t('user.userID')"
                                  prop="userId">
                      <el-input v-model="dataForm.userCode"
                                :placeholder="$t('organization.orgCodeMessage')"
                                :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- 员工号 -->
                    <el-form-item :label="$t('user.userCardNo')"
                                  prop="userCardNo">
                      <el-input v-model="dataForm.userCardNo"
                                :placeholder="$t('organization.orgCodeMessage')"
                                :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- 同意收集隐私 -->
                    <!--<el-form-item :label="$t('user.agreeconceal')"
                                  prop="agreePolicy">
                      <el-select v-model="dataForm.agreePolicy"
                                 clearable
                                 :placeholder="$t('user.select')"
                                 :disabled="true">
                        <el-option v-for="(item,index) in agreePolicy"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>-->
                     <!-- 手机号 -->
                    <el-form-item :label="$t('user.mobile')"
                                  prop="mobile">
                      <el-input v-model="dataForm.mobile"
                                :placeholder="$t('user.mobilePlaceholder')"
                                :disabled="agreePolicyDisable || (this.$route.query.userId && this.$route.query.userId !== '' && dataForm.orgType === '10')"
                                @blur="checkMobileOrEmail(0)"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="row-mar-l">
                  <el-col :span="8">
                    <!-- 组织类型 -->
                    <el-form-item :label="$t('organization.orgType')"
                                  prop="orgType">
                      <el-select v-model="dataForm.orgType"
                                 ref="aaa"
                                 :placeholder="$t('user.orgTypePlaceholder')"
                                 :disabled="editDisable || TAleaveAndJoinDisabled"
                                 @change="changeOrgType">
                        <el-option v-for="(item,index) in neworgType"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- 权限分类 -->
                    <el-form-item :label="$t('user.permissionclassification')"
                                  prop="authType">
                      <el-select v-model="dataForm.authType"
                                 clearable
                                 :placeholder="$t('user.authTypePlaceholder')"
                                 :disabled="myselfDisable || leaveFlag || canEdit"
                                 @change="changeAuthType">
                        <el-option v-for="(item,index) in perClassification"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <!-- 邮箱 -->
                <el-form-item :label="$t('user.userEmail')"
                              prop="email">
                  <el-input v-model="dataForm.email"
                            @blur="checkMobileOrEmail(1)"
                            :disabled="agreePolicyDisable || (this.$route.query.userId && this.$route.query.userId !== '' && dataForm.orgType === '10')"
                            :placeholder="$t('user.inputMail')"></el-input>
                </el-form-item>

                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 最后登录时间 -->
                <el-form-item :label="$t('user.lastlogintime')">
                  <el-input v-model="dataForm.lastLoginTime"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 最后修改密码时间 -->
                <el-form-item :label="$t('user.lastPassword')">
                  <el-input v-model="dataForm.passwordUpdateTime"
                            :placeholder="$t('user.null')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-if="!dataForm.userId || dataForm.userId === ''">
                <!-- 是否允许登录 -->
                <el-form-item :label="$t('user.status10')"
                              prop="loginFlag">
                  <el-select v-model="dataForm.loginFlag"
                             clearable
                             :disabled="true"
                             :placeholder="$t('user.select')">
                    <el-option v-for="(item,index) in leafFlag"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-if="dataForm.userId && dataForm.userId !== ''">
                <el-form-item :label="$t('user.status10')"
                              prop="loginFlag">
                  <el-select v-model="dataForm.loginFlag"
                             clearable
                             :placeholder="$t('user.select')">
                    <el-option v-for="(item,index) in leafFlag"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 紧急联系人及联系方式 -->
                <el-form-item :label="$t('user.emergencyContact')"
                              prop="emergencyContactInfo">
                  <el-input v-model="dataForm.emergencyContactInfo"
                            :placeholder="$t('user.emergencyContactInput')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">

              <el-col :span="6"
                      v-if="dataForm.userId && dataForm.userId != ''">
                <!-- 身份证照片已上传 -->
                <el-form-item :label="$t('user.idcardUploadFlag')"
                              prop="mobile">
                  <el-input v-model="dataForm.idcardUploadFlagString"
                            :disabled="true"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-if="dataForm.userId && dataForm.userId != ''">
                <!-- 最后一次面部信息识别时间 ，去除与mobile同步校验规则-->
                <el-form-item :label="$t('user.lastFaceVerifyTime')"
                              prop="lastFaceVerifyTime">
                  <el-input v-model="dataForm.lastFaceVerifyTime"
                            :disabled="true"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-if="!dataForm.userId || dataForm.userId === ''">
                <el-form-item :label="$t('user.privacyFileUrl')">
                  <el-checkbox v-model="privacyChecked"
                               @change="showAgreement">同意隐私协议</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-if="dataForm.loginFlag === '20'">
                <el-form-item :label="$t('user.deactivatedReason')"
                              prop="deactivatedReason">
                  <el-input v-model="dataForm.deactivatedReason"
                            :placeholder="$t('user.deactivatedReasonInput')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-if="dataForm.userId && dataForm.userId !== ''">
                    <el-form-item :label="$t('user.agreeconceal')"
                                  prop="agreePolicy">
                      <el-select v-model="dataForm.agreePolicy"
                                 clearable
                                 :placeholder="$t('user.select')"
                                 :disabled="true">
                        <el-option v-for="(item,index) in agreePolicy"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                </el-col>
              <!-- <el-col :span="18"
                      style="text-align: center">
                <el-form-item :label="$t('user.privacyFileUrl')"
                              prop="privacyFileUrl"
                              style="width:93.3% !important;">
                  <div class="inline"
                       v-if="privacyFileUrl && privacyFileUrl !== ''">
                    <a target="_blank"
                       :href='privacyFileUrl'
                       style="margin: 5px">用户隐私协议</a>
                    <div class="redText">点击链接可以在线预览</div>
                  </div>
                  <el-upload class="upload-demo"
                             ref="upload"
                             :action="uploadUrl"
                             accept=".pdf"
                             :multiple="false"
                             :show-file-list="false"
                             :file-list="fileList"
                             :on-success="handleAvatarSuccess"
                             :before-upload="beforeAvatarUpload">
                    <el-button size="small"
                               style="margin: 5px">上传PDF文件</el-button>
                  </el-upload>
                  <el-button size="small"
                             type="primary"
                             @click="submitDownload"
                             style="margin: 5px">模板下载</el-button>
                </el-form-item>
              </el-col> -->
            </el-row>
          </div>
          <!-- 业务信息 -->
          <div class="opten-title">
            <em class="el-icon-caret-right"></em>{{$t('user.business')}}</div>
          <div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 服务宝马开始日期 -->
                <el-form-item :label="$t('organization.joinDateBmw')"
                              prop="value">
                  <el-date-picker v-model="dataForm.bmwJoinDate"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 在职状态 -->
                <el-form-item :label="$t('user.incumbency')"
                              prop="jobStatus">
                  <el-select :placeholder="dataForm.jobStatus"
                             clearable
                             :disabled="jobStatusDisable"
                             v-model="dataForm.jobStatus"
                             @change="jobStatusabled">
                    <el-option v-for="(item,index) in jobStatus"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入当前公司日期 -->
                <el-form-item :label="$t('user.accessionDate')"
                              prop="orgJoinDate"
                              v-if="!dataForm.userId || dataForm.userId === ''||(dataForm.userId && dataForm.leaveDate ==='') ">
                  <el-date-picker v-model="dataForm.orgJoinDate"
                                  type="date"
                                  :editable='false'
                                  v-on:input="orgJoinDateabled"
                                  :placeholder="$t('user.input')"
                                  :disabled="joindateabled"
                                  value-format="yyyy-MM-dd 00:00:00">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入当前公司日期 -->
                <el-form-item :label="$t('user.accessionDate')"
                              prop="orgJoinDate"
                              v-if="dataForm.userId && dataForm.leaveDate !=='' && dataForm.userId !== ''">
                  <el-date-picker v-model="dataForm.orgJoinDate"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离职日期 -->
                <el-form-item :label="$t('user.leaveDate')"
                              prop="leaveDate"
                              v-if="leavedateshow">
                  <el-date-picker v-model="dataForm.leaveDate"
                                  type="date"
                                  v-on:input="leaveDateabled"
                                  :disabled="leaveFlag"
                                  :placeholder="$t('user.input')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 宝龄 -->
                <el-form-item :label="$t('user.BMWtime')"
                              prop="bmwSeniority">
                  <el-input v-model="dataForm.bmwSeniority"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <!-- 角色 -->
              <el-col :span="12"
                      style="text-align:center">
                <el-form-item :label="$t('user.role')"
                              prop="roleId"
                              style="width:90% !important;">
                  <el-select v-model="dataForm.roleId"
                             multiple
                             :disabled="TAleaveAndJoinDisabled || leaveFlag"
                             collapse-tags
                             @change="roledChenge"
                             :placeholder="$t('organization.orgCodeBring')"
                             class="roletext">
                    <el-option v-for="(item,index) in rolelist"
                               :key="index"
                               :label="item.roleName"
                               :value="item.roleId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="groupshow">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.GWMinformation')}}</div>
            <el-row class="row-mar-l">
              <!-- 宝马集团信息 -->
              <el-col :span="6">
                <!-- 所属公司 -->
                <el-form-item :label="$t('user.GWMcompany')"
                              prop="GWMcompany">
                  <el-select :placeholder="$t('user.orgPlaceholder')"
                             clearable
                             remote
                             filterable
                             reserve-keyword
                             v-model="bmwgroup"
                             :disabled="!jobabled || TAleaveAndJoinDisabled"
                             :remote-method="querySearchCompany"
                             @change="bmwgroupChange(bmwgroup,0)">
                    <el-option v-for="item in companyresults"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 部门 -->
                <el-form-item :label="$t('user.department')"
                              prop="bmwDeptCode">
                  <el-input v-model="dataForm.bmwDeptCode"
                            maxlength="20"
                            :placeholder="$t('user.deptPlaceholder')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 宝马集团职位 -->
                <el-form-item :label="$t('user.posit')"
                              prop="jobCode">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="this.dataForm.jobCode === '' || !this.dataForm.jobCode">
                    <div slot="content"
                         v-html="jobCodeContent"></div>
                    <el-select v-model="dataForm.jobCode"
                               :placeholder="$t('user.positionPlaceholder')"
                               :disabled="!jobCodeshow"
                               remote
                               clearable
                               filterable
                               reserve-keyword
                               :remote-method="queryMainPosition"
                               @change="jobChange(dataForm.jobCode)">
                      <el-option v-for="item in positionlist"
                                 :key="item.positionCode"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div v-if="outGroupShow">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.outletGroupinformation')}}</div>
            <el-row class="row-mar-l">
              <!-- 经销商集团信息 -->
              <el-col :span="6">
                <!-- 所属公司 -->
                <el-form-item :label="$t('user.GWMcompany')"
                              prop="outcompany">
                  <el-select :placeholder="$t('user.orgPlaceholder')"
                             clearable
                             remote
                             filterable
                             reserve-keyword
                             v-model="outGroup"
                             :disabled="!jobabled || TAleaveAndJoinDisabled"
                             :remote-method="querySearchCompany"
                             @change="bmwgroupChange(outGroup,2)">
                    <el-option v-for="item in companyresults"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 经销商集团职位 -->
                <el-form-item :label="$t('user.posit')"
                              prop="jobCode">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="this.dataForm.jobCode === '' || !this.dataForm.jobCode">
                    <div slot="content"
                         v-html="jobCodeContent"></div>
                    <el-select v-model="dataForm.jobCode"
                               :placeholder="$t('user.positionPlaceholder')"
                               :disabled="!jobCodeshow"
                               remote
                               clearable
                               filterable
                               reserve-keyword
                               :remote-method="queryMainPosition"
                               @change="jobChange(dataForm.jobCode)">
                      <el-option v-for="item in positionlist"
                                 :key="item.positionCode"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="partnershow">
            <!-- 合作伙伴/合作院校信息 -->
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('organization.orgType2030')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 所属公司 -->
                <el-form-item :label="$t('user.GWMcompany')"
                              prop="partnerCompany">
                  <el-select :placeholder="$t('user.orgPlaceholder')"
                             v-model="partnter"
                             remote
                             clearable
                             filterable
                             reserve-keyword
                             :disabled="!jobabled || TAleaveAndJoinDisabled"
                             :remote-method="querySearchCompany"
                             @change="bmwgroupChange(partnter,1)">
                    <el-option v-for="item in companyresults"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 合作伙伴职位 -->
                <el-form-item :label="$t('user.posit')"
                              prop="jobCode">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="this.dataForm.jobCode === '' || !this.dataForm.jobCode">
                    <div slot="content"
                         v-html="jobCodeContent"></div>
                    <el-select v-model="dataForm.jobCode"
                               :placeholder="$t('user.positionPlaceholder')"
                               :disabled="!jobCodeshow"
                               remote
                               clearable
                               filterable
                               reserve-keyword
                               :remote-method="queryMainPosition"
                               @change="jobChange(dataForm.jobCode)">
                      <el-option v-for="item in positionlist"
                                 :key="item.positionCode"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 经销商信息 -->
          <div v-if="companyshow">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.dealer')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 所属经销商网点 -->
                <el-form-item :label="$t('user.outlet')"
                              prop="outletID">
                  <el-select v-model="outletID"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :placeholder="$t('user.outletIDPlaceholder')"
                             :remote-method="querySearch"
                             @change="orgIdCheck(outletID)"
                             :disabled="outletIDshow || TAleaveAndJoinOutletDisabled">
                    <el-option v-for="item in results"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6"> -->
              <!-- 加入网点日期 -->
              <!-- <el-form-item :label="$t('user.accessionDate2')"
                              prop="networkJoinDate">
                  <el-date-picker v-model="dataForm.networkJoinDate"
                                  type="date"
                                  :placeholder="$t('user.select')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <!-- 所属品牌 -->
                <el-form-item :label="$t('user.brandCodes')">
                  <el-input v-model="dataForm.brandCode"
                            :disabled="true"
                            :placeholder="$t('organization.orgCodeMessage')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 所属BBA No -->
                <el-form-item :label="$t('user.bbaNo')"
                              prop="">
                  <el-input v-model="dataForm.bbaNo"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 所属NSC No -->
                <el-form-item :label="$t('user.nscno')"
                              prop="">
                  <el-input v-model="dataForm.nscNo"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 网点类型 -->
                <el-form-item :label="$t('user.outletType')"
                              prop="">
                  <el-input v-model="dataForm.outletType"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-show="false">
                <!-- 职级 -->
                <el-form-item :label="$t('user.joblevl')">
                  <el-select :placeholder="$t('user.select')"
                             v-model="dataForm.jobLevel"
                             clearable>
                    <el-option v-for="(item,index) in jobLevel"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 当前岗龄 -->
                <el-form-item :label="$t('user.jobyear')"
                              prop="">
                  <el-input v-model="dataForm.jobcodeAge"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 主要职位 -->
                <el-form-item :label="$t('user.position')"
                              prop="jobCode">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="dataForm.jobCode === '' || !dataForm.jobCode">
                    <div slot="content"
                         v-html="jobCodeContent"></div>
                    <el-select v-model="dataForm.jobCode"
                               :placeholder="$t('user.mainJobPH')"
                               :disabled="!jobCodeshow"
                               remote
                               filterable
                               reserve-keyword
                               clearable
                               :remote-method="queryMainPosition"
                               @change="jobLimit(dataForm.jobCode)">
                      <el-option v-for="item in positionlist"
                                 :key="item.positionCode"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入该职位日期 -->
                <el-form-item :label="$t('user.joinjobdate')"
                              prop="jobcodeJoinDate">
                  <el-date-picker v-model="dataForm.jobcodeJoinDate"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开该职位日期 -->
                <el-form-item :label="$t('user.leavejobdate')"
                              prop="jobcodeLeaveDate">
                  <el-date-picker v-model="dataForm.jobcodeLeaveDate"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">

              <!-- 兼职1所属网点 -->
              <el-col :span="6">
                <el-form-item :label="$t('user.outlet1')">
                  <el-select v-model="dataForm.partTimeOutletOne"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :placeholder="$t('user.partOrgPH')"
                             :remote-method="querySearchPart0"
                             @change="partOrgChange(dataForm.partTimeOutletOne, 0)"
                             :disabled="partOrgShow">
                    <el-option v-for="item in partResults0"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职职位1 -->
                <el-form-item :label="$t('user.parttimejob1')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="dataForm.partTimeJobcodeOne === '' || !dataForm.partTimeJobcodeOne">
                    <div slot="content"
                         v-html="jobCodeContentOne"></div>
                    <el-select v-model="dataForm.partTimeJobcodeOne"
                               :placeholder="$t('user.partJobPH')"
                               clearable
                               remote
                               filterable
                               reserve-keyword=""
                               :remote-method="queryJobPart0"
                               :disabled="parttimeShow0"
                               @change="parttimejobRepeat(dataForm.partTimeJobcodeOne, 'One', 0)">
                      <el-option v-for="(item,index) in parttimejobList0"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职1日期 -->
                <el-form-item :label="$t('user.joinparttimejob1')"
                              prop="jobcodeJoinDateOne">
                  <el-date-picker v-model="dataForm.jobcodeJoinDateOne"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职1日期 -->
                <el-form-item :label="$t('user.leaveparttimejob1')"
                              prop="jobcodeLeaveDateOne">
                  <el-date-picker v-model="dataForm.jobcodeLeaveDateOne"
                                  type="date"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <!-- 兼职2所属网点 -->
              <el-col :span="6">
                <el-form-item :label="$t('user.outlet2')">
                  <el-select v-model="dataForm.partTimeOutletTwo"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :placeholder="$t('user.partOrgPH')"
                             :remote-method="querySearchPart1"
                             @change="partOrgChange(dataForm.partTimeOutletTwo, 1)"
                             :disabled="partOrgShow">
                    <el-option v-for="item in partResults1"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职2 -->
                <el-form-item :label="$t('user.parttimejob2')"
                              prop="partTimeJobcodeTwo">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="dataForm.partTimeJobcodeTwo === '' || !dataForm.partTimeJobcodeTwo">
                    <div slot="content"
                         v-html="jobCodeContentTwo"></div>
                    <el-select v-model="dataForm.partTimeJobcodeTwo"
                               :placeholder="$t('user.partJobPH')"
                               clearable
                               remote
                               filterable
                               reserve-keyword=""
                               :remote-method="queryJobPart1"
                               :disabled="parttimeShow1"
                               @change="parttimejobRepeat(dataForm.partTimeJobcodeTwo, 'Two', 1)">
                      <el-option v-for="(item,index) in parttimejobList1"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职2日期 -->
                <el-form-item :label="$t('user.joinparttimejob2')"
                              prop="jobcodeJoinDateTwo">
                  <el-date-picker v-model="dataForm.jobcodeJoinDateTwo"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职2日期 -->
                <el-form-item :label="$t('user.leaveparttimejob2')"
                              prop="jobcodeLeaveDateTwo">
                  <el-date-picker v-model="dataForm.jobcodeLeaveDateTwo"
                                  type="date"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <!-- 兼职3所属网点 -->
              <el-col :span="6">
                <el-form-item :label="$t('user.outlet3')">
                  <el-select v-model="dataForm.partTimeOutletThree"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :placeholder="$t('user.partOrgPH')"
                             :remote-method="querySearchPart2"
                             @change="partOrgChange(dataForm.partTimeOutletThree, 2)"
                             :disabled="partOrgShow">
                    <el-option v-for="item in partResults2"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职3 -->
                <el-form-item :label="$t('user.parttimejob3')"
                              prop="partTimeJobcodeThree">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="dataForm.partTimeJobcodeThree === '' || !dataForm.partTimeJobcodeThree">
                    <div slot="content"
                         v-html="jobCodeContentThree"></div>
                    <el-select v-model="dataForm.partTimeJobcodeThree"
                               :placeholder="$t('user.partJobPH')"
                               clearable
                               remote
                               filterable
                               reserve-keyword=""
                               :remote-method="queryJobPart2"
                               :disabled="parttimeShow2"
                               @change="parttimejobRepeat(dataForm.partTimeJobcodeThree, 'Three', 2)">
                      <el-option v-for="(item,index) in parttimejobList2"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职3日期 -->
                <el-form-item :label="$t('user.joinparttimejob3')"
                              prop="jobcodeJoinDateTwo">
                  <el-date-picker v-model="dataForm.jobcodeJoinDateThree"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职3日期 -->
                <el-form-item :label="$t('user.leaveparttimejob3')"
                              prop="jobcodeLeaveDateThree">
                  <el-date-picker v-model="dataForm.jobcodeLeaveDateThree"
                                  type="date"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <!-- 兼职4所属网点 -->
              <el-col :span="6">
                <el-form-item :label="$t('user.outlet4')">
                  <el-select v-model="dataForm.partTimeOutletFour"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :placeholder="$t('user.partOrgPH')"
                             :remote-method="querySearchPart3"
                             @change="partOrgChange(dataForm.partTimeOutletFour, 3)"
                             :disabled="partOrgShow">
                    <el-option v-for="item in partResults3"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职4 -->
                <el-form-item :label="$t('user.parttimejob4')"
                              prop="partTimeJobcodeFour">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="dataForm.partTimeJobcodeFour === '' || !dataForm.partTimeJobcodeFour">
                    <div slot="content"
                         v-html="jobCodeContentFour"></div>
                    <el-select v-model="dataForm.partTimeJobcodeFour"
                               :placeholder="$t('user.partJobPH')"
                               clearable
                               remote
                               filterable
                               reserve-keyword=""
                               :remote-method="queryJobPart3"
                               :disabled="parttimeShow3"
                               @change="parttimejobRepeat(dataForm.partTimeJobcodeFour, 'Four', 3)">
                      <el-option v-for="(item,index) in parttimejobList3"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职4日期 -->
                <el-form-item :label="$t('user.joinparttimejob4')"
                              prop="jobcodeJoinDateFour">
                  <el-date-picker v-model="dataForm.jobcodeJoinDateFour"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职4日期 -->
                <el-form-item :label="$t('user.leaveparttimejob4')"
                              prop="jobcodeLeaveDateFour">
                  <el-date-picker v-model="dataForm.jobcodeLeaveDateFour"
                                  type="date"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <!-- 兼职5所属网点 -->
              <el-col :span="6">
                <el-form-item :label="$t('user.outlet5')">
                  <el-select v-model="dataForm.partTimeOutletFive"
                             remote
                             filterable
                             reserve-keyword
                             clearable
                             :placeholder="$t('user.partOrgPH')"
                             :remote-method="querySearchPart4"
                             @change="partOrgChange(dataForm.partTimeOutletFive, 4)"
                             :disabled="partOrgShow">
                    <el-option v-for="item in partResults4"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职5 -->
                <el-form-item :label="$t('user.parttimejob5')"
                              prop="partTimeJobcodeFive">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="dataForm.partTimeJobcodeFive === '' || !dataForm.partTimeJobcodeFive">
                    <div slot="content"
                         v-html="jobCodeContentFive"></div>
                    <el-select v-model="dataForm.partTimeJobcodeFive"
                               :placeholder="$t('user.partJobPH')"
                               clearable
                               remote
                               filterable
                               reserve-keyword=""
                               :remote-method="queryJobPart4"
                               :disabled="parttimeShow4"
                               @change="parttimejobRepeat(dataForm.partTimeJobcodeFive, 'Five', 4)">
                      <el-option v-for="(item,index) in parttimejobList4"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职5日期 -->
                <el-form-item :label="$t('user.joinparttimejob5')"
                              prop="jobcodeJoinDateFive">
                  <el-date-picker v-model="dataForm.jobcodeJoinDateFive"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职5日期 -->
                <el-form-item :label="$t('user.leaveparttimejob5')"
                              prop="jobcodeLeaveDateFive">
                  <el-date-picker v-model="dataForm.jobcodeLeaveDateFive"
                                  type="date"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- BEST学员信息 -->
          <div v-if="studentshow && false">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.beststudent')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 预签约经销商 -->
                <el-form-item :label="$t('user.reservedDistributor')"
                              prop="dealerShipId">
                  <el-select v-model="dataForm.dealerShipId"
                             remote
                             clearable
                             filterable
                             reserve-keyword
                             :placeholder="$t('user.dealerPlaceholder')"
                             :remote-method="orgquerySearch">
                    <el-option v-for="(item,index) in orgResulets"
                               :key="index"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 是否同意入人才库 -->
              <!-- <el-col :span="6">
                <el-form-item :label="$t('user.joininDistributor')"
                              prop="talentBankFlag">
                  <el-select v-model="dataForm.talentBankFlag"
                             :disabled="true"
                             clearable
                             :placeholder="$t('user.select')">
                    <el-option v-for="(item,index) in joinorleave"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <!-- BEST候选人账号 -->
                <el-form-item :label="$t('user.numberbankaccount')"
                              prop="officialAccountFlag">
                  <el-select v-model="dataForm.officialAccountFlag"
                             :placeholder="$t('user.select')"
                             clearable>
                    <el-option v-for="(item,index) in regularid"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 专业 -->
              <!-- <el-col :span="6">
                <el-form-item :label="$t('user.major')"
                              prop="majorCode">
                  <el-select :placeholder="$t('user.select')"
                             v-model="dataForm.majorCode"
                             clearable>
                    <el-option v-for="(item,index) in majorlist"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 在校状态 -->
                <el-form-item :label="$t('user.graduation')"
                              prop="graduateStatus">
                  <el-select :placeholder="$t('user.graduateStatusPlaceholder')"
                             v-model="dataForm.graduateStatus"
                             clearable>
                    <el-option v-for="(item,index) in graduationStatus"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 入校时间 -->
                <el-form-item :label="$t('user.joinschool')"
                              v-show="dataForm.graduateStatus == '10'"
                              prop="joinschool">
                  <el-date-picker v-model="dataForm.enterSchoolDate"
                                  type="date"
                                  @change="enterSchoolDateChange(dataForm.enterSchoolDate)"
                                  :placeholder="$t('user.enterSchoolPlaceholder')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离校时间 -->
                <el-form-item :label="$t('user.leaveschool')"
                              v-show="dataForm.graduateStatus == '20' || dataForm.graduateStatus == '30'"
                              prop="leaveschool">
                  <el-date-picker v-model="dataForm.leaveSchoolDate"
                                  type="date"
                                  @change="leaveSchoolDateChange(dataForm.leaveSchoolDate)"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>

            </el-row>
          </div>
          <div v-if="teachershow">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.trainer')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 培训师分类 -->
                <el-form-item :label="$t('user.trainerall')"
                              prop="teacherType">
                  <el-select v-model="dataForm.teacherType"
                             :placeholder="$t('user.select')"
                             clearable>
                    <el-option v-for="(item,index) in teacherType"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 试讲结束日期 -->
                <el-form-item :label="$t('user.enddateftrialtalk')"
                              prop="trialEndDate">
                  <el-date-picker v-model="dataForm.trialEndDate"
                                  type="date"
                                  :placeholder="$t('user.checkdate')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 培训师团队分类 -->
                <el-form-item :label="$t('user.trainerteam')"
                              prop="teacherGroupCode">
                  <el-select v-model="dataForm.teacherGroupCode"
                             :placeholder="$t('user.select')"
                             clearable>
                    <el-option v-for="(item,index) in teaTeamClass"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 培训师角色 -->
                <el-form-item :label="$t('user.trainerrole')"
                              prop="">
                  <el-input v-model="dataForm.teacherRole"
                            :placeholder="$t('user.input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 生效日期 -->
                <el-form-item :label="$t('user.effectivedate')"
                              prop="availabilityDate">
                  <el-date-picker v-model="dataForm.availabilityDate"
                                  type="date"
                                  :placeholder="$t('user.checkdate')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 年度培训目标 -->
                <el-form-item :label="$t('user.trainingobjectives')"
                              prop="annualTrainingObj">
                  <el-input v-model="dataForm.annualTrainingObj"
                            :placeholder="$t('user.input')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 合同号 -->
                <el-form-item :label="$t('user.contractnumber')"
                              prop="">
                  <el-input v-model="dataForm.contractCode"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 培训师级别 -->
                <el-form-item :label="$t('user.teacherlvel')"
                              prop="teacherGrade">
                  <el-select :placeholder="dataForm.teacherGrade"
                             v-model="dataForm.teacherGrade"
                             clearable>
                    <el-option v-for="(item,index) in teacherLevel"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 职位 -->
                <el-form-item :label="$t('dimission.jobCode')"
                              prop="teacherjobCode">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="right"
                              :disabled="dataForm.jobCode === '' || !dataForm.jobCode">
                    <div slot="content"
                         v-html="jobCodeContent"></div>
                    <el-select v-model="teacherjobCode"
                               :placeholder="$t('user.select')"
                               clearable>
                      <el-option v-for="item in positionlist"
                                 :key="item.positionCode"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入该职位日期 -->
                <el-form-item :label="$t('user.joinjobdate')"
                              prop="teacherJobcodeJoinDate1">
                  <el-date-picker v-model="teacherjobCodeJoinDate"
                                  type="date"
                                  :placeholder="$t('user.select')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开该职位日期 -->
                <el-form-item :label="$t('user.leavejobdate')"
                              prop="teacherJobcodeLeaveDate">
                  <el-date-picker v-model="teacherjobCodeLeaveDate"
                                  type="date"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="this.applyShow ==='10' && this.dataForm.authType === '10'">
            <el-row class="row-mar-l">
              <el-col :span="6">
                <el-form-item>
                  <!-- 选取文件 -->
                  <el-upload class="upload-demo"
                             ref="upload"
                             accept=".pdf,.PDF,.jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.PNG"
                             :show-file-list="false"
                             :data="myData"
                             :headers="myHeader"
                             :action="uploadUrl"
                             :on-preview="handlePreview"
                             :on-remove="handleRemove"
                             :on-success="handleSuccess"
                             :before-upload="beforeExcelUpload"
                             :file-list="fileList"
                             :auto-upload="true"
                             :multiple="false"
                             :on-change="changeFile">
                    <el-button slot="trigger"
                               type="primary"
                               style="margin-top: 27px; width: 200px">选择上传文件
                                <el-tooltip placement="top-start" effect="light" :content="$t('authApply.fileFormatContent')">
                                       <em class="el-icon-question"></em>
                                </el-tooltip>
                    </el-button>
                    <el-link type="primary"
                             @click="downloadTemplate" style="margin-left:7px">模板下载</el-link>
                    <!-- <div slot="tip"
                         class="el-upload__tip">只支持PDF格式，文件不得超过20MB</div> -->
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('authApply.fileName')"
                              prop="fileContent"
                              :rules="this.dataForm.fileContent === ''||this.dataForm.fileContent === null||this.dataForm.fileContent === undefined? dataRule.fileContent:
            [{ required: false, message: this.$t('validate.required'), trigger: 'change' }]">
                  <!-- <el-input v-model="dataForm.fileContent"
                            :disabled="true"
                            @click.native="downloadFile"
                            class="custom"></el-input> -->
                       <el-input v-model="dataForm.fileContent"
                            :disabled="true"
                            @click.native="downloadFile"
                            class="fl-input"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="btn-left btn-mar-t">
          <el-button type="primary"
                     :disabled="isDisable || (saved && !privacyChecked && (!dataForm.userId || dataForm.userId === ''))"
                     @click="dataFormSubmitHandle()">{{$t('user.save')}}</el-button>
          <el-button @click="back">{{$t('user.back')}}</el-button>
        </div>
      </el-tab-pane>
      <!-- 历史版本 -->
      <el-tab-pane v-for="(item,index) in historydataForm"
                   :key="item.value"
                   :label="$t('user.history')+(index+1)"
                   @click="handleClick(index)">
        <div v-show="headDateShow"
             class="headDate">
          {{headDateHistory}}
        </div>
        <el-form label-position="top"
                 :inline="true"
                 ref="historydataForm">
          <!-- 基本信息 -->
          <div class="opten-title">
            <em class="el-icon-caret-right"></em>{{$t('organization.basicInformation')}}
          </div>
          <div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 证件类型 -->
                <el-form-item :label="$t('user.idtype')">
                  <el-select v-model="historydataForm1.idType"
                             clearable
                             :disabled="true"
                             :placeholder="$t('user.idtype')">
                    <el-option v-for="(item,index) in idTypeList"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 身份证护照 -->
                <el-form-item :label="$t('user.passportIdcard')">

                  <el-input v-model="historydataForm1.idcard"
                            placeholder=""
                            :disabled="true"
                            maxlength="18"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 出生日期 -->
                <el-form-item :label="$t('user.dateofbirth')"
                              prop="birthday">
                  <el-date-picker v-model="historydataForm1.birthday"
                                  type="date"
                                  placeholder=""
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 性别 -->
                <el-form-item :label="$t('user.gender')">
                  <el-select v-model="historydataForm1.sexCode"
                             placeholder=""
                             :disabled="true">
                    <el-option v-for="(item,index) in sexCode"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 证件编号 -->
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 姓 -->
                <el-form-item :label="$t('user.firstname')">
                  <el-input v-model="historydataForm1.lastName"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 名 -->
                <el-form-item :label="$t('user.lastname')">
                  <el-input v-model="historydataForm1.firstName"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 姓名 -->
                <el-form-item :label="$t('user.name')">
                  <el-input v-model="historydataForm1.userName"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 学历 -->
                <el-form-item :label="$t('user.education')">
                  <el-select v-model="historydataForm1.educationCode"
                             clearable
                             :placeholder="$t('user.select')"
                             :disabled="true">
                    <el-option v-for="(item,index) in educationCode"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 账号信息 -->
          <div>
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{ $t('user.accountinformation') }}
            </div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <div class="img-div">
                  <img alt="" :src="historydataForm1.headurl" />
                </div>
              </el-col>
              <el-col :span="18">

                <el-row class="row-mar-l">
                  <el-col :span="8">
                    <!-- 用户id -->
                    <el-form-item :label="$t('user.userID')">
                      <el-input v-model="historydataForm1.userCode"
                                placeholder=""
                                :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- 员工号 -->
                    <el-form-item :label="$t('user.userCardNo')">
                      <el-input v-model="historydataForm1.userCardNo"
                                placeholder=""
                                :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- 同意收集隐私 -->
                    <!-- <el-form-item :label="$t('user.agreeconceal')">
                      <el-select v-model="historydataForm1.agreePolicy"
                                 clearable
                                 placeholder=""
                                 :disabled="true">
                        <el-option v-for="(item,index) in agreePolicy"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>-->
                     <!-- 手机号 -->
                    <el-form-item :label="$t('user.mobile')">
                      <el-input v-model="historydataForm1.mobile"
                                placeholder=""
                                :disabled="true"
                                maxlength="11"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="row-mar-l">
                  <el-col :span="8">
                    <!-- 组织类型 -->
                    <el-form-item :label="$t('organization.orgType')">
                      <el-select v-model="historydataForm1.orgType"
                                 :placeholder="$t('user.select')"
                                 clearable
                                 :disabled="editDisable"
                                 @change="changeOrgType">
                        <el-option v-for="(item,index) in neworgType"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- 权限分类 -->
                    <el-form-item :label="$t('user.permissionclassification')">
                      <el-select v-model="historydataForm1.authType"
                                 clearable
                                 placeholder=""
                                 :disabled="true">
                        <el-option v-for="(item,index) in perClassification"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <!-- 邮箱 -->
                    <el-form-item :label="$t('user.userEmail')">
                      <el-input v-model="historydataForm1.email"
                                :disabled="true"
                                placeholder=""></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 最后登录时间 -->
                <el-form-item v-show="false"
                              :label="$t('user.lastlogintime')">
                  <el-input v-model="historydataForm1.lastLoginTime"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 最后修改密码时间 -->
                <el-form-item v-show="false"
                              :label="$t('user.lastPassword')">
                  <el-input v-model="historydataForm1.passwordUpdateTime"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 是否允许登录 -->
                <el-form-item :label="$t('user.status10')">
                  <el-select v-model="historydataForm1.loginFlag"
                             clearable
                             :disabled="true"
                             placeholder="">
                    <el-option v-for="(item,index) in leafFlag"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">

              </el-col>
            </el-row>
            <!-- Spring4 -->
            <el-row class="row-mar-l">
              <el-col :span="6">
                <el-form-item :label="$t('user.emergencyContact')"
                              prop="emergencyContactInfo">
                  <el-input v-model="historydataForm1.emergencyContactInfo"
                            :placeholder="$t('user.emergencyContactInput')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12"
                      style="text-align: center">
                <el-form-item :label="$t('user.privacyFileUrl')"
                              prop="privacyFileUrl"
                              style="width:90% !important">
                  <div class="inline"
                       v-if="privacyFileUrlHistory && privacyFileUrlHistory !== ''">
                    <a target="_blank"
                       :href='privacyFileUrlHistory'
                       style="margin: 5px">用户隐私协议</a>
                    <div class="redText">点击链接可以在线预览</div>
                  </div>
                </el-form-item>
              </el-col> -->
            </el-row>
          </div>
          <!-- 业务信息 -->
          <div class="opten-title">
            <em class="el-icon-caret-right"></em>{{$t('user.business')}}
          </div>
          <el-form label-position="top"
                   :inline="true">
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 服务宝马开始日期 -->
                <el-form-item :label="$t('organization.joinDateBmw')">
                  <el-date-picker v-model="historydataForm1.bmwJoinDate"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 在职状态 -->
                <el-form-item :label="$t('user.incumbency')">
                  <el-select placeholder=""
                             v-model="historydataForm1.jobStatus"
                             :disabled="true">
                    <el-option v-for="(item,index) in jobStatus"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入当前公司日期 -->
                <el-form-item :label="$t('user.accessionDate')"
                              v-if="accessionDateshow">
                  <el-date-picker v-model="historydataForm1.orgJoinDate"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 角色 -->
              <!-- <el-col :span="6">
              <el-form-item :label="$t('user.role')"
                            prop="partTimeJobcodeOne">
                <el-select v-model="historydataForm1.roleId"
                           placeholder=""
                           :disabled="true">
                  <el-option v-for="item in historyrolelist"
                             :key="item.value"
                             :label="item.roleName"
                             :value="item.roleId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
              <el-col :span="6">
                <!-- 离职日期 -->
                <el-form-item :label="$t('user.leaveDate')"
                              v-if="leavedateshow">
                  <el-date-picker v-model="historydataForm1.leaveDate"
                                  type="date"
                                  placeholder=""
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- </el-row>
          <el-row class="row-mar-l"> -->
              <el-col :span="6">
                <!-- 宝龄 -->
                <el-form-item :label="$t('user.BMWtime')">
                  <el-input v-model="historydataForm1.bmwSeniority"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form label-position="top"
                   :inline="true"
                   v-if="groupshow">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.GWMinformation')}}</div>
            <el-row class="row-mar-l">
              <!-- 宝马集团信息 -->
              <el-col :span="6">
                <!-- 所属公司 -->
                <el-form-item :label="$t('user.GWMcompany')">
                  <el-select :placeholder="$t('user.input')"
                             v-model="historybwmcompany"
                             :disabled="true">
                    <el-option v-for="(item,index) in historycompanyresults"
                               :key="index"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 部门 -->
                <el-form-item :label="$t('user.department')">
                  <el-input v-model="historydataForm1.bmwDeptCode"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 宝马集团职位 -->
                <el-form-item :label="$t('user.position')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top">
                    <div slot="content"
                         v-html="historyjobCodeContent"></div>
                    <el-select v-model="historydataForm1.jobCode"
                               :disabled="true">
                      <el-option v-for="(item,index) in historyPositionlist"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div v-if="outGroupShow">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.outletGroupinformation')}}</div>
            <el-row class="row-mar-l">
              <!-- 经销商集团信息 -->
              <el-col :span="6">
                <!-- 所属公司 -->
                <el-form-item :label="$t('user.GWMcompany')"
                              prop="outcompany">
                  <el-select :placeholder="$t('user.orgPlaceholder')"
                             clearable
                             remote
                             filterable
                             reserve-keyword
                             v-model="historybwmcompany"
                             :disabled="true">
                    <el-option v-for="item in historycompanyresults"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 职位 -->
                <el-form-item :label="$t('user.posit')"
                              prop="jobCode">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top">
                    <div slot="content"
                         v-html="historyjobCodeContent"></div>
                    <el-select v-model="historydataForm1.jobCode"
                               :disabled="true">
                      <el-option v-for="(item,index) in historyPositionlist"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-form label-position="top"
                   :inline="true"
                   v-if="partnershow">
            <!-- 合作伙伴/合作院校信息 -->
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('organization.orgType2030')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 公司 -->
                <el-form-item :label="$t('user.GWMcompany')">
                  <el-select v-model="historypartnter"
                             :disabled="true">
                    <el-option v-for="(item,index) in historycompanyresults"
                               :key="index"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 合作伙伴职位 -->
                <el-form-item :label="$t('dimission.jobCode')"
                              prop="">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top">
                    <div slot="content"
                         v-html="historyjobCodeContent"></div>
                    <el-select :placeholder="$t('user.select')"
                               v-model="historydataForm1.jobCode"
                               :disabled="true"
                               clearable>
                      <el-option v-for="(item,index) in historyPositionlist"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form label-position="top"
                   :inline="true"
                   v-if="companyshow">
            <!-- 经销商信息 -->
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.dealer')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 所属经销商网点 -->
                <el-form-item :label="$t('user.outlet')">
                  <el-select v-model="historydataForm1.orgId"
                             remote
                             reserve-keyword
                             :disabled="true">
                    <el-option v-for="item in historyResults"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 加入网点日期 -->
              <!-- <el-col :span="6">
              <el-form-item :label="$t('user.accessionDate2')">
                <el-date-picker v-model="historydataForm1.networkJoinDate"
                                type="date"
                                :disabled="true"
                                placeholder=""
                                value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
              <el-col :span="6">
                <!-- 所属品牌 -->
                <el-form-item :label="$t('user.brandCodes')">
                  <el-input v-model="historydataForm1.brandCode"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 所属BBA No -->
                <el-form-item :label="$t('user.bbaNo')">
                  <el-input v-model="historydataForm1.bbaNo"
                            :placeholder="$t('user.input')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 所属NSN No -->
                <el-form-item :label="$t('user.nscno')">
                  <el-input v-model="historydataForm1.nscNo"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 网点类型 -->
                <el-form-item :label="$t('user.outletType')"
                              prop="">
                  <el-input v-model="historydataForm1.outletType"
                            :placeholder="$t('organization.orgCodeMessage')"
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6"
                      v-show="false">
                <!-- 职级 -->
                <el-form-item :label="$t('user.joblevl')">
                  <el-select :placeholder="$t('user.select')"
                             v-model="historydataForm1.jobLevel"
                             :disabled="true">
                    <el-option v-for="(item,index) in jobLevel"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 当前岗龄 -->
                <el-form-item :label="$t('user.jobyear')">
                  <el-input v-model="historydataForm1.jobcodeAge"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 主要职位 -->
                <el-form-item :label="$t('user.position')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top"
                              :disabled="!historydataForm1.jobCode || historydataForm1.jobCode === ''">
                    <div slot="content"
                         v-html="historyjobCodeContent"></div>
                    <el-select v-model="historydataForm1.jobCode"
                               placeholder=""
                               :disabled="true">
                      <el-option v-for="(item,index) in historyPositionlist"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入该职位日期 -->
                <el-form-item :label="$t('user.joinjobdate')">
                  <el-date-picker v-model="historydataForm1.jobcodeJoinDate"
                                  placeholder=""
                                  type="date"
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开该职位日期 -->
                <el-form-item :label="$t('user.leavejobdate')">
                  <el-date-picker v-model="historydataForm1.jobcodeLeaveDate"
                                  type="date"
                                  placeholder=""
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">

              <el-col :span="6">
                <!-- 兼职1所属网点 -->
                <el-form-item :label="$t('user.outlet1')">
                  <el-select v-model="historydataForm1.partTimeOutletOne"
                             remote
                             reserve-keyword
                             :disabled="true">
                    <el-option v-for="item in historyPartResults0"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职1 -->
                <el-form-item :label="$t('user.parttimejob1')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top"
                              :disabled="!historydataForm1.partTimeJobcodeOne || historydataForm1.partTimeJobcodeOne === ''">
                    <div slot="content"
                         v-html="historyjobCodeContentOne"></div>
                    <el-select placeholder=""
                               v-model="historydataForm1.partTimeJobcodeOne"
                               :disabled="true">
                      <el-option v-for="(item,index) in historyParttimejobList0"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职1日期 -->
                <el-form-item :label="$t('user.joinparttimejob1')">
                  <el-date-picker v-model="historydataForm1.jobcodeJoinDateOne"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职1日期 -->
                <el-form-item :label="$t('user.leaveparttimejob1')">
                  <el-date-picker v-model="historydataForm1.jobcodeLeaveDateOne"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">

              <el-col :span="6">
                <!-- 兼职2所属网点 -->
                <el-form-item :label="$t('user.outlet2')">
                  <el-select v-model="historydataForm1.partTimeOutletTwo"
                             remote
                             reserve-keyword
                             :disabled="true">
                    <el-option v-for="item in historyPartResults1"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职2 -->
                <el-form-item :label="$t('user.parttimejob2')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top"
                              :disabled="!historydataForm1.partTimeJobcodeTwo || historydataForm1.partTimeJobcodeTwo === ''">
                    <div slot="content"
                         v-html="historyjobCodeContentTwo"></div>
                    <el-select placeholder=""
                               v-model="historydataForm1.partTimeJobcodeTwo"
                               :disabled="true">
                      <el-option v-for="(item,index) in historyParttimejobList1"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职2日期 -->
                <el-form-item :label="$t('user.joinparttimejob2')">
                  <el-date-picker v-model="historydataForm1.jobcodeJoinDateTwo"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职2日期 -->
                <el-form-item :label="$t('user.leaveparttimejob2')">
                  <el-date-picker v-model="historydataForm1.jobcodeLeaveDateTwo"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">

              <el-col :span="6">
                <!-- 兼职3所属网点 -->
                <el-form-item :label="$t('user.outlet3')">
                  <el-select v-model="historydataForm1.partTimeOutletThree"
                             remote
                             reserve-keyword
                             :disabled="true">
                    <el-option v-for="item in historyPartResults2"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职3 -->
                <el-form-item :label="$t('user.parttimejob3')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top"
                              :disabled="!historydataForm1.partTimeJobcodeThree || historydataForm1.partTimeJobcodeThree === ''">
                    <div slot="content"
                         v-html="historyjobCodeContentThree"></div>
                    <el-select placeholder=""
                               v-model="historydataForm1.partTimeJobcodeThree"
                               :disabled="true">
                      <el-option v-for="(item,index) in historyParttimejobList2"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职3日期 -->
                <el-form-item :label="$t('user.joinparttimejob3')">
                  <el-date-picker v-model="historydataForm1.jobcodeJoinDateThree"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职3日期 -->
                <el-form-item :label="$t('user.leaveparttimejob3')">
                  <el-date-picker v-model="historydataForm1.jobcodeLeaveDateThree"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">

              <el-col :span="6">
                <!-- 兼职4所属网点 -->
                <el-form-item :label="$t('user.outlet4')">
                  <el-select v-model="historydataForm1.partTimeOutletFour"
                             remote
                             reserve-keyword
                             :disabled="true">
                    <el-option v-for="item in historyPartResults3"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职4 -->
                <el-form-item :label="$t('user.parttimejob4')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top"
                              :disabled="!historydataForm1.partTimeJobcodeFour || historydataForm1.partTimeJobcodeFour === ''">
                    <div slot="content"
                         v-html="historyjobCodeContentFour"></div>
                    <el-select placeholder=""
                               v-model="historydataForm1.partTimeJobcodeFour"
                               :disabled="true">
                      <el-option v-for="(item,index) in historyParttimejobList3"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职4日期 -->
                <el-form-item :label="$t('user.joinparttimejob4')">
                  <el-date-picker v-model="historydataForm1.jobcodeJoinDateFour"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职4日期 -->
                <el-form-item :label="$t('user.leaveparttimejob4')">
                  <el-date-picker v-model="historydataForm1.jobcodeLeaveDateFour"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">

              <el-col :span="6">
                <!-- 兼职5所属网点 -->
                <el-form-item :label="$t('user.outlet5')">
                  <el-select v-model="historydataForm1.partTimeOutletFive"
                             remote
                             reserve-keyword
                             :disabled="true">
                    <el-option v-for="item in historyPartResults4"
                               :key="item.orgId"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 兼职5 -->
                <el-form-item :label="$t('user.parttimejob5')">
                  <el-tooltip class="item"
                              effect="dark"
                              placement="top"
                              :disabled="!historydataForm1.partTimeJobcodeFive || historydataForm1.partTimeJobcodeFive === ''">
                    <div slot="content"
                         v-html="historyjobCodeContentFive"></div>
                    <el-select placeholder=""
                               v-model="historydataForm1.partTimeJobcodeFive"
                               :disabled="true">
                      <el-option v-for="(item,index) in historyParttimejobList4"
                                 :key="index"
                                 :label="item.positionName"
                                 :value="item.positionCode">
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入兼职5日期 -->
                <el-form-item :label="$t('user.joinparttimejob5')">
                  <el-date-picker v-model="historydataForm1.jobcodeJoinDateFive"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开兼职5日期 -->
                <el-form-item :label="$t('user.leaveparttimejob5')">
                  <el-date-picker v-model="historydataForm1.jobcodeLeaveDateFive"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form label-position="top"
                   :inline="true"
                   v-if="studentshow && false">
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.beststudent')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 预留签约经销商 -->
                <el-form-item :label="$t('user.reservedDistributor')">
                  <el-select v-model="historydataForm1.dealerShipId"
                             placeholder=""
                             :disabled="true">
                    <el-option v-for="(item,index) in orgResuletsHistory"
                               :key="index"
                               :label="item.name"
                               :value="item.orgId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 是否同意入人才库 -->
              <!-- <el-col :span="6">
                <el-form-item :label="$t('user.joininDistributor')">
                  <el-select placeholder=""
                             v-model="historydataForm1.talentBankFlag"
                             :disabled="true">
                    <el-option v-for="(item,index) in joinorleave"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <!-- 是否正式账号 -->
                <el-form-item :label="$t('user.numberbankaccount')">
                  <el-select placeholder=""
                             v-model="historydataForm1.officialAccountFlag"
                             :disabled="true">
                    <el-option v-for="(item,index) in regularid"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 专业 -->
              <!-- <el-col :span="6">
                <el-form-item :label="$t('user.major')">
                  <el-select placeholder=""
                             v-model="historydataForm1.majorCode"
                             :disabled="true">
                    <el-option v-for="(item,index) in majorlist"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 入校时间 -->
                <el-form-item :label="$t('user.joinschool')">
                  <el-date-picker v-model="historydataForm1.enterSchoolDate"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离校时间 -->
                <el-form-item :label="$t('user.leaveschool')">
                  <el-date-picker v-model="historydataForm1.leaveSchoolDate"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 毕业状态 -->
                <el-form-item :label="$t('user.graduation')">
                  <el-select placeholder=""
                             v-model="historydataForm1.graduateStatus"
                             :disabled="true">
                    <el-option v-for="(item,index) in graduationStatus"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form label-position="top"
                   :inline="true"
                   v-if="teachershow">
            <!-- 培训师信息 -->
            <div class="opten-title">
              <em class="el-icon-caret-right"></em>{{$t('user.trainer')}}</div>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 培训师分类 -->
                <el-form-item :label="$t('user.trainerall')">
                  <el-select placeholder=""
                             v-model="historydataForm1.teacherType"
                             :disabled="true">
                    <el-option v-for="(item,index) in teacherType"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 试讲结束日期 -->
                <el-form-item :label="$t('user.enddateftrialtalk')">
                  <el-date-picker v-model="historydataForm1.trialEndDate"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 培训师团队分类 -->
                <el-form-item :label="$t('user.trainerteam')">
                  <el-select placeholder=""
                             v-model="historydataForm1.teacherGroupCode"
                             :disabled="true">
                    <el-option v-for="(item,index) in teacherType"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 培训师角色 -->
                <el-form-item :label="$t('user.trainerrole')">
                  <el-input v-model="historydataForm1.teacherRole"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 生效日期 -->
                <el-form-item :label="$t('user.effectivedate')">
                  <el-date-picker v-model="historydataForm1.availabilityDate"
                                  type="date"
                                  :disabled="true"
                                  placeholder=""
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 年度培训目标 -->
                <el-form-item :label="$t('user.trainingobjectives')">
                  <el-input v-model="historydataForm1.annualTrainingObj"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <!-- TA级别 -->
              <el-col :span="6">
                <!-- 合同号 -->
                <el-form-item :label="$t('user.contractnumber')">
                  <el-input v-model="dataForm.contractCode"
                            placeholder=""
                            :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 教师级别 -->
                <el-form-item :label="$t('user.teacherlvel')">
                  <el-select placeholder=""
                             v-model="historydataForm1.teacherGrade"
                             :disabled="true">
                    <el-option v-for="(item,index) in teacherLevel"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="row-mar-l">
              <el-col :span="6">
                <!-- 主要职位 -->
                <el-form-item :label="$t('dimission.jobCode')">
                  <el-select v-model="historydataForm1.jobCode"
                             :placeholder="$t('user.input')"
                             :disabled="true">
                    <el-option v-for="item in positionlist"
                               :key="item.positionCode"
                               :label="item.positionName"
                               :value="item.positionCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 加入该职位日期 -->
                <el-form-item :label="$t('user.joinjobdate')">
                  <el-date-picker v-model="historydataForm1.jobcodeJoinDate"
                                  type="date"
                                  :placeholder="$t('user.select')"
                                  :disabled="true"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 离开该职位日期 -->
                <el-form-item :label="$t('user.leavejobdate')">
                  <el-date-picker v-model="historydataForm1.jobcodeLeaveDate"
                                  type="date"
                                  :disabled="true"
                                  :placeholder="$t('organization.orgCodeMessage')"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!-- 弹窗, 修改头像 -->
    <modifyImg v-if="modifyImgVisible"
               @refreshImg="refreshImg"
               ref="modifyImg"></modifyImg>
    <!-- 弹窗, 用户协议 -->
    <Agreement v-if="agreementVisible"
               @func="agreementEmit"
               ref="agreement"></Agreement>
    <!-- 限制弹框 -->
    <el-dialog
      :title="$t('prompt.title')"
      :append-to-body="true"
      :modal-append-to-body="false"
      custom-class="user-transfer-islimit-modal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="limitShow"
      :before-close="closeLimitModal"
      :width="isLimit ? '760px' : '420px'">
        <LimitInfoModal v-if="limitShow" :isLimit="isLimit" :factoryDesc="factoryDesc" @closeLimitModal="closeLimitModal"></LimitInfoModal>
    </el-dialog>
  </el-card>
</template>
<script>
import Vue from 'vue'
import VueI18n, { messages } from '@/i18n'
import debounce from 'lodash/debounce'
import ModifyImg from '../../protal/modifyImg'
import Agreement from '../../protal/agreement'
import AddressSelect from '../../../components/address-select/index.vue'
import $ from 'jquery'
import AesUtil from "@/utils/aes_utils";
import LimitInfoModal from '@/views/modules/acdc/limitAccess/limitModal';

// 宝马集团
const ORG_TYPE_BMWG = '10'
// 合作伙伴
const ORG_PARTANER = '20'
// 合作院校
const ORG_SCHOOL = '30'
// 经销商集团
const ORG_GROUP = '40'
// 经销商
const ORG_ALL = '50'
// 经销商网点
const ORG_OUTLED = '60'
// admin
const AUTHTYPE_ADMIN = '10'
// 普通用户
const AUTHTYPE_USER = '20'
// 老师
const AUTHTYPE_TEACHER = '30'
// 管理层
const AUTHTYPE_LAYER = '40'
// best学员
const AUTHTYPE_BESTSTUDENT = '50'
export default {
  data() {
    const messagesConst = messages[VueI18n.locale]
    let _this = this
    return {
      privacyChecked: false,
      saved: false,
      agreementVisible: false, // 隐私协议弹框
      refsForm: {}, // 传递给父组件的流程参数
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      select: messagesConst.user.select,
      value: [],
      list: [],
      jobCodeAll: '',
      jobCodeshow: true,
      partTimejobCodeOneshow: false,
      partTimejobCodeTwoshow: false,
      partTimejobCodeThreeshow: false,
      partTimejobCodeFourshow: false,
      partTimejobCodeFiveshow: false,
      historycompanyresults: [],
      // 预留签约经销商
      orgResulets: [],
      // 历史版本预留签约经销商
      orgResuletsHistory: [],
      // 宝马集团
      companyresults: [],
      // 伙伴公司
      historyPositionlist: [],
      // 是否允许登录
      leafFlag: _this.enums['confirmState'],
      // 转圈
      loading: false,
      // BMW group show
      groupshow: false,
      // 经销商集团
      outGroupShow: false,
      // 合作伙伴
      partnershow: false,
      // 公司
      companyshow: false,
      // best学员
      studentshow: false,
      // best老师
      teachershow: false,
      // 离职日期
      leavedateshow: true,
      // 加入日期是否输入
      joindateabled: false,
      // 工作是否输入
      jobabled: false,
      // 组织类型
      orgType: '',
      // 角色列表
      rolelist: [],
      // 记录初始入职时间
      joincompny: '',
      // 记录初始离职日期
      leaveCompany: '',
      // 职位列表
      positionlist: [],
      // 兼职列表
      parttimejoblist: [],
      // 加入日期
      accessionDateshow: true,
      // 入学时间
      joinschooldate: '',
      // 离校时间
      leaveschoolDate: '',
      // 当前时间
      nowdata: '',
      // 组织类型
      neworgType: '',
      // 在职状态
      jobStatus: _this.enums['jobStatus'],
      // 网点
      outletID: '',
      // 组织类型
      userorgType: _this.enums['orgType'],
      // 性别
      sexCode: _this.enums['sex'],
      // 学历
      educationCode: _this.enums['educationCode'],
      // 是否同意收集隐私
      agreePolicy: _this.enums['agreePolicy'],
      // 登录
      loginFlag: _this.enums['loginFlag'],
      // 职级
      jobLevel: _this.enums['jobLevel'],
      // 权限分类
      perClassification: _this.enums['perClassification'],
      // 状态
      status: _this.enums['status'],
      // // 所属品牌
      // brandCode: _this.enums['brandCode'],
      // 毕业状态
      graduationStatus: _this.enums['graduationStatus'],
      // 是否同意加入人才库
      joinorleave: _this.enums['confirmState'],
      // 审批流程
      registration: _this.enums['registration'],
      // 是否正式账号
      regularid: _this.enums['confirmState'],
      // 专业
      majorlist: _this.enums['majorlist'],
      // 培训师分类
      teacherType: _this.enums['teacherType'],
      // 培训师团队分类
      teaTeamClass: _this.enums['teaTeamClass'],
      // 教师级别
      teacherLevel: _this.enums['teacherLevel'],
      // 证件类型
      idTypeList: _this.enums['idType'],
      // 角色
      // roleIds: [],
      // 历史版本角色
      historyrolelist: '',
      partnerJobCode: false,
      dataForm: {
        idType: '10',
        headurl: require('@/assets/img/default-image.png'),
        idcard: '',
        agreePolicy: '10',
        userId: '',
        userCardNo: '',
        // 添加拼音对象 gyq
        lastName: '',
        firstName: '',
        // 添加拼音对象 gyq
        roleId: [],
        jobCode: '',
        educationCode:'70',
        jobcodeJoinDate: '',
        passwordUpdateTime: '',
        jobcodeLeaveDate: '',
        partTimeJobcodeOne: '',
        partTimeJobcodeTwo: '',
        partTimeOutletOne: '',
        partTimeOutletTwo: '',
        partTimeJobcodeThree: '',
        partTimeJobcodeFour: '',
        jobcodeJoinDateOne: '',
        jobcodeJoinDateTwo: '',
        jobcodeJoinDateThree: '',
        jobcodeJoinDateFour: '',
        jobcodeLeaveDateTwo: '',
        jobcodeLeaveDateThree: '',
        jobcodeLeaveDateFour: '',
        jobcodeLeaveDateOne: '',
        birthday: '',
        sexCode: '',
        leaveDate: '',
        orgJoinDate: '',
        loginFlag: '10',
        brandCode: '',
        jobStatus: '10',
        enterSchoolDate: '',
        leaveSchoolDate: '',
        orgType: '20',
        authType: '',
        deactivatedReason: '',
        templeteFileName: ''
      },
      // 宝马集团
      bmwgroup: '',
      outGroup: '',
      // 合作伙伴
      partnter: '',
      // 合作伙伴职位
      partnterJob: '',
      // 历史版本合作伙伴
      historypartnter: '',
      // 历史版本宝马集团
      historybwmcompany: '',
      // 历史版本离职日期
      historyLeaveDate: '',
      historyparttimejoblist: [],
      job: '',
      teacherjobCodeJoinDate: '',
      teacherjobCodeLeaveDate: '',
      teacherjobCode: '',
      leave: '10',
      jianzhiorgJoinDate: '',
      // 主要职位信息描述
      jobCodeNum: this.$t('activiti.jobCodeNum'),
      jobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      historyjobCodeNum: this.$t('activiti.jobCodeNum'),
      historyjobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 兼职职位描述
      jobCodeNumOne: this.$t('activiti.jobCodeNum'),
      jobCodeNumTwo: this.$t('activiti.jobCodeNum'),
      jobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentThree: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFour: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFive: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      historyjobCodeNumOne: this.$t('activiti.jobCodeNum'),
      historyjobCodeNumTwo: this.$t('activiti.jobCodeNum'),
      historyjobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      historyjobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 兼职数组
      parttimeCheckedList: [null, null, null, null],
      // 历史版本列表
      historydataForm: [],
      historydataForm1: [],
      results: [],
      historyResults: [],
      addshow: true,
      deleteshow: false,
      activeName2: 'first',
      id: '',
      // 兼职1职位列表
      parttimejobList0: [],
      // 兼职2职位列表
      parttimejobList1: [],
      // 兼职3职位列表
      parttimejobList2: [],
      // 兼职4职位列表
      parttimejobList3: [],
      // 兼职5职位列表
      parttimejobList4: [],
      // 加入公司日期
      orgJoinDate: '',
      // 活动状态是否可以编辑
      jobStatusDisable: false,
      outletIDshow: false,
      placeBirthday: this.$t('user.selectBirthday'),
      placeSex: this.$t('user.selectSex'),
      newperClassification: '',
      oldperClassification: '',
      editDisable: false,
      // 是否显示修改头像
      modifyImgVisible: false,
      userImg: require('../../../assets/img/uimg2.jpg'),
      // 兼职网点是否显示
      partOrgShow: true,
      // 兼职职位1是否显示
      parttimeShow0: true,
      // 兼职职位2是否显示
      parttimeShow1: true,
      // 兼职职位3是否显示
      parttimeShow2: true,
      // 兼职职位4是否显示
      parttimeShow3: true,
      // 兼职职位5是否显示
      parttimeShow4: true,
      // 兼职网点list
      partResults0: [],
      partResults1: [],
      partResults2: [],
      partResults3: [],
      partResults4: [],
      // 兼职网点list
      historyPartResults0: [],
      historyPartResults1: [],
      historyPartResults2: [],
      historyPartResults3: [],
      historyPartResults4: [],
      // 历史兼职1职位列表
      historyParttimejobList0: [],
      // 历史兼职2职位列表
      historyParttimejobList1: [],
      // 历史兼职3职位列表
      historyParttimejobList2: [],
      // 历史兼职4职位列表
      historyParttimejobList3: [],
      // 历史兼职5职位列表
      historyParttimejobList4: [],
      // 离职再入职form
      leaveAndJoinForm: {
        idType: '',
        idcard: '',
        birthday: '',
        bmwSeniority: 0,
        currentVersionDate: '',
        sexCode: '',
        firstName: '',
        lastName: '',
        userName: '',
        educationCode: '70',
        headurl: '',
        userCode: '',
        userCardNo: '',
        agreePolicy: '',
        orgType: '',
        authType: '',
        mobile: '',
        lastLoginTime: '',
        passwordUpdateTime: '',
        loginFlag: '',
        email: '',
        bmwJoinDate: '',
        orgJoinDate: '',
        roleId: '',
        userId: ''
      },
      // 离职再入职不可编辑
      leaveAndJoinDisabled: false,
      // 离职再入职不可编辑角色
      TAleaveAndJoinDisabled: false,
      // 离职再入职不可编辑角色
      TAleaveAndJoinOutletDisabled: false,
      // 离职在入职的离职日期
      leaveAndJoinLeaveDate: '',
      // 是否离职在入职
      leaveAndJoinFlag: false,
      // 获取管理员用户信息
      userData: {},
      // 获取管理员身份
      roleTypeVal: '3',
      userForm: '',
      headId: '',
      myselfDisable: false,
      // 修改头像按钮是否显示
      headModifyShow: false,
      // 隐私协议文件
      fileList: [],
      uploadUrl: '',
      //url: '/sys/config/privacyFileUpload',
      // 隐私协议
      privacyFileUrl: '',
      privacyFileUrlHistory: '',
      agreePolicyDisable: false,
      headDateShow: false,
      headDate: '',
      headDateHistory: '',
      leaveFlag: false,
      readOnly: false,
      sysTime: '',
      //uploadUrl: '',
      url: '/sys/commAdminFileManagement/uploadFileMT',
      myHeader: { token: '' },
      //fileList: [],
      myData: {},
      applyShow: '',
      dataMap: {},
      canEdit: false,
      isDisable: false,
      limitShow: false,
      isLimit: false,
      factoryDesc: ''
    }
  },
  computed: {
    dataRule() {
      // 入职日期校验
      let accessionDate = (rule, value, callback) => {
        if (this.jobabled === false) {
          callback()
        }
        //let beforethreemonth = new Date(Date.parse(this.sysTime.replace(/-/g, '/'))).getTime() - 3600 * 1000 * 24 * 31
        let afterthreemonth = new Date(Date.parse(this.sysTime.replace(/-/g, '/'))).getTime()
        let date1 = new Date(Date.parse(this.sysTime.replace(/-/g, '/')))
        let year = date1.getFullYear()
        var month = date1.getMonth()+1;
        let nowyear = new Date(Date.parse((year + '-' + month + '-' + '01').replace(/-/g, '/'))).getTime()
        let orgJoinDate = Date.parse(this.dataForm.orgJoinDate.replace(/-/g, '/'))
        if (new Date(orgJoinDate).getTime() > afterthreemonth) {
          callback(new Error(this.$t('user.monthOnebyone')))
        } else if (nowyear > new Date(orgJoinDate).getTime()) {
          // 2022-01-18  改为 30 天提示信息
          //callback(new Error(this.$t('user.onebyone')))
          callback(new Error(this.$t('user.monthOnebyone')))
        } else if (this.leaveCompany !== '' && this.leaveCompany !== undefined && this.leaveCompany !== null) {
          if (new Date(orgJoinDate).getTime() < new Date(Date.parse(this.dataForm.leaveDate.replace(/-/g, '/'))).getTime()) {
            callback(new Error(this.$t('user.leaveSmalldate')))
          }
        } else if (this.historyLeaveDate !== '' && this.historyLeaveDate !== null && this.historyLeaveDate !== undefined) {
          if (new Date(orgJoinDate).getTime() < new Date(Date.parse(this.historyLeaveDate.replace(/-/g, '/'))).getTime()) {
            callback(new Error(
              this.$t('user.verificationhistoryLeaveDate')
            ))
          }
        } else {
          callback()
        }
        callback()
      }
      // 离职日期校验
      let leaveDateValidate = (rule, value, callback) => {
        let afterMonth = new Date(Date.parse(this.sysTime.replace(/-/g, '/'))).getTime() + 3600 * 1000 * 24 * 30
        if (this.joincompny !== '' && this.joincompny !== undefined && this.joincompny !== null) {
          if (new Date(this.dataForm.leaveDate).getTime() < new Date(this.dataForm.orgJoinDate).getTime()) {
            callback(new Error(this.$t('user.leaveSmalldate1')))
          }
        } else if (this.orgJoinDate !== '' && this.orgJoinDate !== null && this.orgJoinDate !== undefined) {
          if (new Date(this.dataForm.leaveDate).getTime() < new Date(this.orgJoinDate).getTime()) {
            callback(new Error(this.$t('user.leaveSmalldate1')))
          }
        } else if (new Date(this.dataForm.leaveDate).getTime() > afterMonth) {
          callback(new Error(this.$t('user.leave30date')))
        } else {
          callback()
        }
        callback()
      }
      // 入校日期校验
      let joinSchoolDate = (rule, value, callback) => {
        let goschooltime = new Date(this.dataForm.enterSchoolDate)
        let leaveschooltime = new Date(this.dataForm.leaveSchoolDate)
        if (this.dataForm.enterSchoolDate !== '' && this.dataForm.enterSchoolDate !== undefined && this.dataForm.enterSchoolDate !== '' && this.dataForm.leaveSchoolDate !== '' && this.dataForm.leaveSchoolDate !== undefined && this.dataForm.leaveSchoolDate !== null) {
          if (goschooltime > leaveschooltime) {
            callback(new Error(this.$t('user.leavejoinschooldate')))
          } else {
            callback()
          }
        } else {
          callback()
        }
        callback()
      }
      // 离校日期校验
      let leaveSchoolDate = (rule, value, callback) => {
        let goschooltime = new Date(this.dataForm.enterSchoolDate)
        let leaveschooltime = new Date(this.dataForm.leaveSchoolDate)
        if (this.dataForm.enterSchoolDate !== '' && this.dataForm.enterSchoolDate !== undefined && this.dataForm.enterSchoolDate !== '' && this.dataForm.leaveSchoolDate !== '' && this.dataForm.leaveSchoolDate !== undefined && this.dataForm.leaveSchoolDate !== null) {
          if (goschooltime > leaveschooltime) {
            callback(new Error(this.$t('user.leavejoinschooldate1')))
          } else {
            callback()
          }
        }
        callback()
      }
      // 入校日期校验
      let goJobDate = (rule, value, callback) => {
        if (this.dataForm.jobCode !== '' && this.dataForm.jobCode !== undefined) {
          if (this.dataForm.jobcodeJoinDate === '' || this.dataForm.jobcodeJoinDate === undefined || this.dataForm.jobcodeJoinDate === null) {
            callback(new Error(this.$t('user.verificationjobcode')))
          }
          callback()
        }
      }
      // 手机校验
      let validateMobilePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('user.telephone')))
        } else {
          if (value !== '') {
            var reg = /^\d{6,15}$/
            if (!reg.test(value)) {
              callback(new Error(this.$t('user.telphone615')))
            }
          }
          callback()
        }
      }

      // 姓校验
      let validateFirstName = (rule, value, callback) => {
        for (let i = 0; i < this.dataForm.firstName.length; i++) {
          if (this.dataForm.firstName[i] === ' ') {
            callback(new Error(this.$t('user.verificationfirstname1')))
          }
        }
        let reg = /^(?![·_-]+$)[A-Z·_-]+$/
        let first = reg.test(value)
        if (!first) {
          callback(new Error(this.$t('user.verificationfirstname2')))
        } else {
          callback()
        }
        callback()
      }
      // 名校验
      let validatelastName = (rule, value, callback) => {
        for (let i = 0; i < this.dataForm.lastName.length; i++) {
          if (this.dataForm.lastName[i] === ' ') {
            callback(new Error(this.$t('user.verificationfirstname1')))
          }
        }
        let reg = /^(?![·_-]+$)[A-Z·_-]+$/
        let first = reg.test(value)
        if (!first) {
          callback(new Error(this.$t('user.verificationfirstname2')))
        } else {
          callback()
        }
        callback()
      }
      // 名字校验
      let validateUserName = (rule, value, callback) => {
        for (let i = 0; i < this.dataForm.userName.length; i++) {
          if (this.dataForm.userName[i] === ' ') {
            callback(new Error(this.$t('user.verificationfirstname1')))
          }
        }
        let reg = /^(?![·_-]+$)[\u4e00-\u9fa5a-zA-Z·_-]+$/
        let first = reg.test(value)
        if (!first) {
          callback(new Error(this.$t('user.verificationfirstname3')))
        } else {
          callback()
        }
        callback()
      }
      // 邮箱校验 20201026-1119
      let validateEmail = (rule, value, callback) => {
        //let reg = /^[A-Za-zd0-9]+([-_.][A-Za-zd0-9]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd0-9]{2,5}$/
        let reg = new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")
        if (value === '' || value === undefined || value == null) {
          callback()
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$t('user.verificationemailerrow')))
          } else {
            let regExt = /^[A-Za-zd0-9]+([-_.][A-Za-zd0-9]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd0-9]{2,5}$/
            if (!regExt.test(value)) {
              callback(new Error(this.$t('user.verificationemailerrow')))
            } else {
              callback()
            }
          }
        }
      }
      // 身份证校验
      let validateIdcard = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('user.noIdcard')))
        }
        if (this.dataForm.idType === '10') {
          let date1 = new Date(Date.parse(this.sysTime.replace(/-/g, '/')))
          let today = this.dataForm.birthday
          today = today.split('/')
          let year = date1.getFullYear()
          let month = date1.getMonth() + 1
          let day = date1.getDate()
          if (value && (!(/\d{17}[\d|x]|\d{15}/).test(value) || value.length !== 18 || value.substring(6, 7) === '0' || value.substring(10, 12) > '12' || value.substring(10, 12) === '00' || value.substring(12, 14) > '31' || value.substring(12, 14) === '00')) {
            callback(new Error(this.$t('user.verificationidcarderrow')))
          }
          if ((year - today[0]) < 14 || (year - today[0]) > 71) {
            callback(new Error(this.$t('user.verificationbirthdayerrow')))
          } else if ((year - today[0]) === 14) {
            if ((month - today[1]) < 0) {
              callback(new Error(this.$t('user.verificationbirthdayerrow')))
            } else if ((month - today[1]) === 0) {
              if ((day - today[2]) < 0) {
                callback(new Error(this.$t('user.verificationbirthdayerrow')))
              }
            } else {
              callback()
            }
          } else if ((year - today[0]) === 71) {
            if ((month - today[1]) > 0) {
              callback(new Error(this.$t('user.verificationbirthdayerrow')))
            } else if ((month - today[1]) === 0) {
              if ((day - today[2]) > 0) {
                callback(new Error(this.$t('user.verificationbirthdayerrow')))
              }
            } else {
              callback()
            }
          } else {
            callback()
          }
        } else if (this.dataForm.idType === '20') {
          let num = /^[a-zA-Z0-9]{7,11}$/
          if (!num.test(value)) {
            callback(new Error(this.$t('user.verificationpassporterrow')))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      // 出生日期校验
      let validatebirthday = (rule, value, callback) => {
        if (value) {
          if (this.dataForm.idType === '20') {
            if (this.dataForm.birthday === '' || this.dataForm.birthday === null || this.dataForm.birthday === undefined) {
              callback(new Error(this.$t('user.verificationbirthday')))
            } else {
              value = value.substring(0, 10)
              value = value.split('-')
            }
            let date1 = new Date(Date.parse(this.sysTime.replace(/-/g, '/')))
            let year = date1.getFullYear()
            let month = date1.getMonth() + 1
            let day = date1.getDate()
            if (value === null) {
              value = ''
            }
            // 判断是否大于14岁小于70岁
            if ((year - value[0]) < 15 || (year - value[0]) > 71) {
              callback(new Error(this.$t('user.verificationbirthdayerrow')))
            } else if ((year - value[0]) === 15) {
              // 判断月份
              if ((month - value[1]) < 0) {
                callback(new Error(this.$t('user.verificationbirthdayerrow')))
                // 判断月份
              } else if ((month - value[1]) === 0) {
                if ((day - value[2]) < 0) {
                  callback(new Error(this.$t('user.verificationbirthdayerrow')))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            } else if ((year - value[0]) === 71) {
              // 判断月份
              if ((month - value[1]) > 0) {
                callback(new Error(this.$t('user.verificationbirthdayerrow')))
              } else if ((month - value[1]) === 0) {
                // 判断月份
                if ((day - value[2]) >= 0) {
                  callback(new Error(this.$t('user.verificationbirthdayerrow')))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            } else {
              callback()
            }
          } else {
            callback()
          }
        } else {
          callback(new Error(this.$t('user.verificationbirthday')))
        }
      }
      // 性别校验
      let validatesexCode = (rule, value, callback) => {
        if (this.dataForm.idType === '20') {
          if (this.dataForm.sexCode === '' || this.dataForm.sexCode === null || this.dataForm.sexCode === undefined) {
            callback(new Error(this.$t('user.verificationsexCode')))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      // 公司校验
      let validatebmwcompany = (rule, value, callback) => {
        if (this.bmwgroup === '' || this.bmwgroup === null || this.bmwgroup === undefined) {
          callback(new Error(this.$t('user.verificationcompany')))
        } else {
          callback()
        }
      }
      // 公司校验
      let validateoutcompany = (rule, value, callback) => {
        if (this.outGroup === '' || this.outGroup === null || this.outGroup === undefined) {
          callback(new Error(this.$t('user.verificationcompany')))
        } else {
          callback()
        }
      }
      let validatepartnercompany = (rule, value, callback) => {
        if (this.partnter === '' || this.partnter === null || this.partnter === undefined) {
          callback(new Error(this.$t('user.verificationcompany')))
        } else {
          callback()
        }
      }
      let validateoutletID = (rule, value, callback) => {
        if (this.outletID === '' || this.outletID === null || this.outletID === undefined) {
          callback(new Error(this.$t('validate.required')))
        } else {
          callback()
        }
      }
      return {
        // 手机
        mobile: [
          { required: true, message: this.$t('user.notelephone'), trigger: 'blur' },
          { validator: validateMobilePhone, trigger: 'blur' }
        ],
        // 身份证
        // idcard: [
        //   { required: true, message: this.$t('user.noidcard'), trigger: 'blur' },
        //   { validator: validateIdcard, trigger: 'blur' }
        // ],
        // 邮件
        email: [
          { validator: this.$validate.validateEMail, trigger: 'blur' },
          { required: true, message: this.$t('user.verificationemail'), trigger: 'blur' },
          { max: 100, message: this.$t('validate.validateLength', { 'handle': '100' }), trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        // 身份类型
        idType: [
          { required: true, message: this.$t('user.noidType'), trigger: 'change' }
        ],
        // 身份证校验
        idcard: [
          { validator: validateIdcard, trigger: 'blur' },
          { validator: this.$validate.validateIsIDcard, trigger: 'blur' },
          { required: true, message: this.$t('user.verificationidcard'), trigger: 'blur' }
        ],
        // 入学校验
        joinschool: [
          { validator: joinSchoolDate, trigger: 'change' }
          // { required: true, message: this.$t('user.validatorJoinSchool'), trigger: 'blur' },
        ],
        // 离校校验
        leaveschool: [
          { validator: leaveSchoolDate, trigger: 'change' }
        ],
        // 姓校验
        firstName: [
          { required: true, message: this.$t('user.verificationlastname'), trigger: 'blur' },
          { min: 1, max: 20, message: this.$t('user.verificationlength') },
          { validator: validateFirstName, trigger: 'blur' }
          // { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ],
        // 名校验
        lastName: [
          { required: true, message: this.$t('user.verificationfirstname'), trigger: 'blur' },
          { min: 1, max: 20, message: this.$t('user.verificationlength') },
          { validator: validatelastName, trigger: 'blur' }
          // { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ],
        // 姓名校验
        userName: [
          { required: true, message: this.$t('user.verificationname'), trigger: 'blur' },
          { min: 1, max: 40, message: this.$t('user.verificationlengthTwo') },
          { validator: validateUserName, trigger: 'blur' }
          // { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ],
        // 是否同意校验
        agreePolicy: [
          { required: true, message: this.$t('user.verificationagreePolicy'), trigger: 'change' }
        ],
        jobcodeJoinDate1: [
          { required: true, validator: goJobDate, trigger: 'blur' }
        ],
        GWMcompany: [
          { required: true, validator: validatebmwcompany, trigger: 'change' }
        ],
        outcompany: [
          { required: true, validator: validateoutcompany, trigger: 'change' }
        ],

        partnerCompany: [
          { required: true, validator: validatepartnercompany, trigger: 'change' }
        ],
        // 组织类型校验
        orgType: [
          { required: true, message: this.$t('user.verificationorgtype'), trigger: 'change' }
        ],
        // 权限分类校验
        authType: [
          { required: true, message: this.$t('user.verificationauthtype'), trigger: 'blur' }
        ],
        // 出生日期校验
        birthday: [
          { required: true, validator: validatebirthday, trigger: 'change' }
        ],
        // 性别校验
        sexCode: [
          { required: true, validator: validatesexCode, trigger: 'change' }
        ],
        // 入职日期校验
        orgJoinDate: [
          { required: true, message: this.$t('user.userorgJoinDate'), trigger: 'blur' },
          { validator: accessionDate, trigger: 'blur' }
        ],
        // 离职日期校验
        leaveDate: [
          { required: true, message: this.$t('user.userleaveDate'), trigger: 'blur' },
          { validator: leaveDateValidate, trigger: 'blur' }
        ],
        // 毕业时间
        graduateStatus: [
          { required: true, message: this.$t('user.verificationgraduate'), trigger: 'change' }
        ],
        // 培训师分类
        teacherType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 试讲结束日期
        trialEndDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 培训师团队分类
        teacherGroupCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 生效日期
        availabilityDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 年度培训目标
        annualTrainingObj: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 培训师级别
        teacherGrade: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 最高学历
        educationCode: [
          { required: false, message: this.$t('user.usereducationCode'), trigger: 'change' }
        ],
        // 在职状态
        jobStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 角色
        roleId: [
          { required: true, message: this.$t('user.userRoleId'), trigger: 'blur' }
        ],
        // 登录状态
        loginFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 加入网点日期
        networkJoinDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 经销商网点
        outletID: [
          { required: true, validator: validateoutletID, trigger: 'change' }
        ],
        // 职位
        jobCode: [
          { required: true, message: this.$t('user.userJobCode'), trigger: 'change' }
        ],
        // 预签约经销商
        dealerShipId: [
          { required: true, message: this.$t('user.validatordealerShipId'), trigger: 'change' }
        ],
        // 是否同意人才入库
        talentBankFlag: [
          { required: true, message: this.$t('user.validatortalentBankFlag'), trigger: 'change' }
        ],
        // BEST候选人账号
        officialAccountFlag: [
          { required: true, message: this.$t('user.validatorofficialAccountFlag'), trigger: 'change' }
        ],
        // 专业
        majorCode: [
          { required: true, message: this.$t('user.validatormajorCode'), trigger: 'change' }
        ],
        // 部门
        bmwDeptCode: [
          { required: true, message: this.$t('user.validatorDept'), trigger: 'blur' }
        ],
        // 紧急联系人及联系方式
        emergencyContactInfo: [
          { required: true, message: this.$t('user.emergencyContactInput'), trigger: 'blur' },
          { max: 40, message: this.$t('validate.validateLength', { 'handle': '40' }), trigger: 'blur' }
        ],
        deactivatedReason: [
          { required: true, message: this.$t('user.deactivatedReasonInput'), trigger: 'blur' },
          { max: 40, message: this.$t('validate.validateLength', { 'handle': '40' }), trigger: 'blur' }
        ],
        fileContent: [
          { required: true, message: this.$t('authApply.uploadFileFirst'), trigger: 'blur' }
        ],
      }
    }
  },
  components: {
    AddressSelect,
    ModifyImg,
    Agreement,
    LimitInfoModal
  },
  methods: {
    // 子组件传递同意不同意
    agreementEmit(data) {
      this.privacyChecked = data
    },
    // 显示隐私协议
    showAgreement(val) {
      if (val) {
        this.agreementVisible = true
        this.$nextTick(() => {
          this.$refs.agreement.init()
        })
      }
    },
    // 隐私协议
    handleAvatarSuccess(response, file) {
      // absolutePath 相对路径用来回显
      this.dataForm.privacyFileUrl = response.data.relativePath
      this.privacyFileUrl = response.data.absolutePath
    },
    beforeAvatarUpload(file) {
      const isPDF = file.type === 'application/pdf'
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPDF) {
        this.$alert(
          this.$t('上传文件只能是 PDF 格式!'), this.$t('prompt.title')
        ).then((res) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      }
      return isPDF
    },
    submitDownload() {
      // var elemIF = document.createElement('iframe')
      // elemIF.src = 'http://172.16.221.113:8080/sys/commuser/download/privacyFile'
      // elemIF.style.display = 'none'
      // document.body.appendChild(elemIF)
      this.$request.download('/sys/commuser/download/privacyFile', '隐私协议.pdf', null, null, 'email')
      // this.$request.get(
      //   '/sys/commuser/download/privacyFile'
      // ).then(
      //   (res, total, code, data) => {}
      // ).catch(() => { })
    },
    converToPinyin(self) {
	    if(this.dataForm.userName != undefined && this.dataForm.userName != ""){
	      this.$request.get('/sys/org/converToPinyin',{
          name: this.dataForm.userName
        }).then((res) => {
          this.dataForm.lastName = res.pinyinFirstName
          this.dataForm.firstName = res.pinyinLastName
		      console.log("姓名转换完毕-------------------")
        }).catch((err) => {
          console.log(err)
        })
	    }else{
	      console.log("姓名为空，不处理")
	    }
    },
    checkMobileOrEmail(index) {
      var data = ''
      var type = ''
      if (index === 0) {
        data = this.dataForm.mobile
        var regMobile = /^\d{6,15}$/
        if (!regMobile.test(data)) {
          return false
        }
        type = 'mobile'
      }
      if (index === 1) {
        data = this.dataForm.email
        var regEmail = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,3})$/
        if (!regEmail.test(data)) {
          return false
        }
        type = 'email'
      }
      var param = {
        mobileOrEmail: data,
        type: type
      }
      // 如果新增
      if (this.jobabled === false) {
        param['userId'] = this.dataForm.userId
      }
      if (this.leaveAndJoinFlag === true) {
        param['userId'] = this.dataForm.userId
      }
      this.$request.get('/sys/commuser/isExist',
        param).then((res, total, code, data) => {
        }).catch((err) => {
          console.log(err)
        })
    },
    refreshImg(data) {
      this.dataForm.headurl = data.url
      this.headId = data.userId
      this.userHeadurl = data.url
      this.headModifyShow = true
      if (data.userId === this.dataForm.userId) {
        this.dataForm.roleTypeVal = data.roleTypeVal
      } else {
        this.dataForm.roleTypeVal = '3'
      }
    },
    modifyImg() {
      this.modifyImgVisible = true
      this.$nextTick(() => {
        this.$refs.modifyImg.init(this.dataForm.userId, 'newbuild')
      })
    },
    // 清除校验
    enterSchoolDateChange(value) {
      if (this.dataForm.enterSchoolDate !== '' && this.dataForm.enterSchoolDate !== null) {
        if (this.dataForm.orgJoinDate !== '' && this.dataForm.orgJoinDate !== null) {
          if (new Date(this.dataForm.orgJoinDate).getTime() > new Date(this.dataForm.enterSchoolDate).getTime()) {
          }
        }
      }
    },
    leaveSchoolDateChange(value) {
      // if (this.dataForm.enterSchoolDate !== '' && this.dataForm.enterSchoolDate !== null && this.dataForm.enterSchoolDate !== undefined) {
      //   if (new Date(value).getTime() > new Date(this.dataForm.enterSchoolDate).getTime()) {
      //     this.$refs.dataForm.clearValidate('joinschool')
      //     this.$refs.dataForm.clearValidate('leaveschool')
      //   }
      // } else if (this.dataForm.enterSchoolDate === null || this.dataForm.leaveSchoolDate === null) {
      //   this.$refs.dataForm.clearValidate('joinschool')
      //   this.$refs.dataForm.clearValidate('leaveschool')
      // }
    },
    bmwgroupChange(orgId, index) {
      this.$nextTick(() => {
        // this.$refs.dataForm.clearValidate('GWMcompany')
        this.$refs.dataForm.clearValidate('partnerCompany')
        this.$refs.dataForm.clearValidate('jobCode')
      })
      this.jobCodeshow = true
      this.dataForm.jobCode = ''
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      if (orgId === '') {
        this.jobCodeshow = false
        this.positionlist = []
        return false
      }
      if (index === 0 && this.bmwgroup === null) {
        this.jobCodeshow = false
      }
      if (index === 1 && this.partnter === null) {
        this.jobCodeshow = false
      }
      if (index === 2 && this.outGroup === null) {
        this.jobCodeshow = false
      }
      this.$request.post('/sys/commuser/commPositionByParam',
        {
          orgType: this.dataForm.orgType,
          orgId: orgId,
          positionName: ''
        }
      ).then((res, total, code, data) => {
        this.positionlist = res
      }).catch((err) => {
        console.log(err)
      })
    },
    partnterChange() {
      this.$refs.dataForm.clearValidate('partnerCompany')
    },
    strFormat(self, key) {
      this.dataForm[key] = self.toUpperCase()
    },
    jobCodeContentChange(jobCode) {
      if (jobCode === '' || jobCode === undefined || jobCode === null) {
        this.jobCodeNum = this.$t('activiti.jobCodeNum')
        this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
      } else {
        for (let i = 0; i < this.positionlist.length; i++) {
          if (jobCode === this.positionlist[i].positionCode) {
            this.jobCodeNum = this.$t('activiti.jobCodeNum') + this.positionlist[i].positionCode
            if (this.positionlist[i].positionDesc) {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + this.positionlist[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    // 职位不可以跟兼职重复
    jobChange(jobCode) {
      // 清空主要职位，兼职，直线经理，只保留一个兼职岗位显示在页面上
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
      this.jobCodeNumOne = this.$t('activiti.jobCodeNum')
      this.jobCodeNumTwo = this.$t('activiti.jobCodeNum')
      this.jobCodeNumThree = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFour = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFive = this.$t('activiti.jobCodeNum')
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')

      this.parttimejobList0 = []
      this.parttimejobList1 = []
      this.parttimejobList2 = []
      this.parttimejobList3 = []
      this.parttimejobList4 = []
      this.dataForm.jobcodeJoinDate = ''
      this.dataForm.partTimeOutletOne = ''
      this.dataForm.partTimeOutletTwo = ''
      this.dataForm.partTimeOutletThree = ''
      this.dataForm.partTimeOutletFour = ''
      this.dataForm.partTimeOutletFive = ''
      this.dataForm.partTimeJobcodeOne = ''
      this.dataForm.partTimeJobcodeTwo = ''
      this.dataForm.partTimeJobcodeThree = ''
      this.dataForm.partTimeJobcodeFour = ''
      this.dataForm.partTimeJobcodeFive = ''
      this.parttimeShow0 = true
      this.parttimeShow1 = true
      this.parttimeShow2 = true
      this.parttimeShow3 = true
      this.parttimeShow4 = true
      this.partOrgShow = true
      if (jobCode && jobCode !== '') {
        //是否需要AC测评
        this.saved = true
        if (this.dataForm.orgType === '60' || this.dataForm.orgType === '50') {
          this.$request.get('/sys/commuser/needEffectiveEvaluation',
            {
              positionCode: jobCode,
              userId: this.dataForm.userId
            }).then((res, total, code, data) => {
              if (code !== 1) {
                let message = '当前AC测评服务不可用，请稍后再试'
                this.$alert(message, this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                this.dataForm.jobCode = ''
                this.saved = false
              } else if (code === 1 && res === 0) {
                let message = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
                this.$alert(message, this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                this.dataForm.jobCode = ''
                this.saved = false
              } else if (code === 1 && res > 0) {
                this.$request.get('/sys/commuser/singlePosition',
                  {
                    positionCode: jobCode,
                    outletId: this.outletID,
                    userId: this.dataForm.userId
                  }
                ).then((res, total, code, data) => {
                  if (res.singlePosition === 1) {
                    // 提示当前岗位单店单岗，已被占用不可选择
                    let entry = this.results.find(item => {
                      if (item.orgId === this.outletID) {
                        return item
                      }
                    })
                    let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
                    this.$alert(message, this.$t('prompt.title')).then((res) => {
                      console.log(res)
                    }).catch((err) => {
                      console.log(err)
                    })
                    this.dataForm.jobCode = ''
                    this.saved = false
                  } else {
                    this.saved = false
                    // 职位描述
                    this.jobCodeContentChange(jobCode)
                    // 兼职网点显示
                    this.partOrgShow = false
                    for (let i = 0; i < this.parttimeCheckedList.length; i++) {
                      if (this.dataForm.jobCode !== '' && this.dataForm.jobCode !== null && this.dataForm.jobCode === this.parttimeCheckedList[i]) {
                        this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then((res) => {
                          console.log(res)
                        }).catch((err) => {
                          console.log(err)
                        })
                        this.dataForm.jobCode = undefined
                      }
                    }
                    if (this.jobCodeAll !== '') {
                      if (this.jobCodeAll !== jobCode) {
                        this.dataForm.partTimeJobcodeOne = ''
                        this.dataForm.partTimeJobcodeTwo = ''
                        this.dataForm.partTimeJobcodeThree = ''
                        this.dataForm.partTimeJobcodeFour = ''
                        this.dataForm.partTimeJobcodeFive = ''
                      }
                    }
                    this.jobCodeAll = jobCode
                    this.parttimejobList0 = []
                    this.parttimejobList1 = []
                    this.parttimejobList2 = []
                    this.parttimejobList3 = []
                    this.parttimejobList4 = []
                    if (this.dataForm.jobCode !== null && this.dataForm.jobCode !== '' && this.dataForm.jobCode !== undefined) {
                      this.dataForm.jobcodeJoinDate = this.dataForm.orgJoinDate
                    } else {
                      this.dataForm.jobcodeJoinDate = ''
                    }
                  }
                }).catch((err) => {
                  console.log(err)
                })
              }
            })
        } else {
          this.$request.get('/sys/commuser/singlePosition',
            {
              positionCode: jobCode,
              outletId: this.outletID,
              userId: this.dataForm.userId
            }
          ).then((res, total, code, data) => {
            if (res.singlePosition === 1) {
              // 提示当前岗位单店单岗，已被占用不可选择
              let entry = this.results.find(item => {
                if (item.orgId === this.outletID) {
                  return item
                }
              })
              let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
              this.$alert(message, this.$t('prompt.title')).then((res) => {

              }).catch((err) => {
                console.log(err)
              })
              this.dataForm.jobCode = ''
              this.saved = false
            } else {
              this.saved = false
              // 职位描述
              this.jobCodeContentChange(jobCode)
              // 兼职网点显示
              this.partOrgShow = false
              for (let i = 0; i < this.parttimeCheckedList.length; i++) {
                if (this.dataForm.jobCode !== '' && this.dataForm.jobCode !== null && this.dataForm.jobCode === this.parttimeCheckedList[i]) {
                  this.$alert(this.$t('user.verificationparttime'), this.$t('prompt.title')).then((res) => {
                    console.log(res)
                  }).catch((err) => {
                    console.log(err)
                  })
                  this.dataForm.jobCode = undefined
                }
              }
              if (this.jobCodeAll !== '') {
                if (this.jobCodeAll !== jobCode) {
                  this.dataForm.partTimeJobcodeOne = ''
                  this.dataForm.partTimeJobcodeTwo = ''
                  this.dataForm.partTimeJobcodeThree = ''
                  this.dataForm.partTimeJobcodeFour = ''
                  this.dataForm.partTimeJobcodeFive = ''
                }
              }
              this.jobCodeAll = jobCode
              this.parttimejobList0 = []
              this.parttimejobList1 = []
              this.parttimejobList2 = []
              this.parttimejobList3 = []
              this.parttimejobList4 = []
              if (this.dataForm.jobCode !== null && this.dataForm.jobCode !== '' && this.dataForm.jobCode !== undefined) {
                this.dataForm.jobcodeJoinDate = this.dataForm.orgJoinDate
              } else {
                this.dataForm.jobcodeJoinDate = ''
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }
      // 切换主职位清空所有兼职信息
      this.dataForm.partTimeJobcodeOne = ''
      this.dataForm.jobcodeJoinDateOne = ''
      this.dataForm.jobcodeLeaveDateOne = ''
      this.dataForm.partTimeJobcodeTwo = ''
      this.dataForm.jobcodeJoinDateTwo = ''
      this.dataForm.jobcodeLeaveDateTwo = ''
      this.dataForm.partTimeJobcodeThree = ''
      this.dataForm.jobcodeJoinDateThree = ''
      this.dataForm.jobcodeLeaveDateThree = ''
      this.dataForm.partTimeJobcodeFour = ''
      this.dataForm.jobcodeJoinDateFour = ''
      this.dataForm.jobcodeLeaveDateFour = ''
      this.dataForm.partTimeJobcodeFive = ''
      this.dataForm.jobcodeJoinDateFive = ''
      this.dataForm.jobcodeLeaveDateFive = ''
      this.parttimeCheckedList = [null, null, null, null]
      this.addshow = true
      this.deleteshow = false
      this.jobCodeNumOne = this.$t('activiti.jobCodeNum')
      this.jobCodeNumTwo = this.$t('activiti.jobCodeNum')
      this.jobCodeNumThree = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFour = this.$t('activiti.jobCodeNum')
      this.jobCodeNumFive = this.$t('activiti.jobCodeNum')
      this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
    },
    jobLimit(jobCode) {
      if (jobCode) {
        let positionId = ''
        this.positionlist.forEach((item) => {
          if (item.positionCode === jobCode) {
            positionId = item.positionId
          }
        })
        this.isLimitTest(positionId, jobCode)
      }
    },
    // 是否限制测评
    isLimitTest(jobCode, jobCode2) {
      this.$request.post(
        '/acdc/restrict/checkRecruitment',
        {
          jobId: jobCode,
          userId: this.dataForm.userId
        }
      ).then((res) => {
        if (res) {
          if (res.restrictFlag) {
            this.limitShow = true
            this.isLimit = res.restrictFlag
            this.factoryDesc = res.remark
          } else {
            this.jobChange(jobCode2)
          }
        }
      })
    },
    closeLimitModal() {
      this.dataForm.jobCode = ''
      this.limitShow = false
    },
    // 兼职不可以重复
    parttimejobRepeat(el, key, num) {
      let _this = this
      _this.isDisable = true
      // 先查询是否为单店单岗
      this.$request.get('/sys/commuser/singlePosition',
        {
          positionCode: el,
          outletId: this.dataForm['partTimeOutlet' + key],
          userId: this.dataForm.userId
        }
      ).then((res, total, code, data) => {
        _this.isDisable = false
        this['jobCodeNum' + key] = this.$t('activiti.jobCodeNum')
        this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent')
        if (res.singlePosition === 1) {
          // 提示当前岗位单店单岗，已被占用不可选择
          let entry

          switch(num){
            case 0:
            entry = this.partResults0.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletOne) {
                return item
              }
            })
            break;
            case 1:
             entry = this.partResults1.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletTwo) {
                return item
              }
            })
            break;
            case 2:
            entry = this.partResults2.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletTwo) {
                return item
              }
            })
            break;
            case 3:
            entry = this.partResults3.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletTwo) {
                return item
              }
            })
            break;
            case 4:
            entry = this.partResults4.find(item => {
              if (item.orgId === this.dataForm.partTimeOutletTwo) {
                return item
              }
            })
            break;
          }

          let message = '当前岗位已经被 “' + entry.name + '” 的 “' + res.userName + '(' + res.userCode + ')' + '” 占用，不可选择'
          this.$alert(message, this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
          _this.dataForm['partTimeJobcode' + key] = ''
          _this.dataForm['jobcodeJoinDate' + key] = ''
          _this.dataForm['jobcodeLeaveDate' + key] = ''
          return false
        } else {
          //将已添加的网点加职位添加到集合中，用来判断是否重复
          let outletCodeArr = [];
          //添加主职
          outletCodeArr.push(_this.outletID+"-"+_this.dataForm.jobCode)
          //添加兼职1
          if(_this.dataForm['partTimeOutletOne']&&_this.dataForm['partTimeJobcodeOne']){
            outletCodeArr.push(_this.dataForm['partTimeOutletOne']+"-"+_this.dataForm['partTimeJobcodeOne'])
          }
          //添加兼职2
          if(_this.dataForm['partTimeOutletTwo']&&_this.dataForm['partTimeJobcodeTwo']){
            outletCodeArr.push(_this.dataForm['partTimeOutletTwo']+"-"+_this.dataForm['partTimeJobcodeTwo'])
          }
          //添加兼职3
          if(_this.dataForm['partTimeOutletThree']&&_this.dataForm['partTimeJobcodeThree']){
            outletCodeArr.push(_this.dataForm['partTimeOutletThree']+"-"+_this.dataForm['partTimeJobcodeThree'])
          }
          //添加兼职4
          if(_this.dataForm['partTimeOutletFour']&&_this.dataForm['partTimeJobcodeFour']){
            outletCodeArr.push(_this.dataForm['partTimeOutletFour']+"-"+_this.dataForm['partTimeJobcodeFour'])
          }
          //添加兼职5
          if(_this.dataForm['partTimeOutletFive']&&_this.dataForm['partTimeJobcodeFive']){
            outletCodeArr.push(_this.dataForm['partTimeOutletFive']+"-"+_this.dataForm['partTimeJobcodeFive'])
          }

          //进行去重
          let uniqueArr = Array.from(new Set(outletCodeArr))

          if(outletCodeArr.length != uniqueArr.length){
             _this.$alert(_this.$t('user.verificationparttime'), _this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                _this.dataForm['partTimeJobcode' + key] = ''
                _this.dataForm['jobcodeJoinDate' + key] = ''
                _this.dataForm['jobcodeLeaveDate' + key] = ''
                return false
          }

            _this.dataForm['jobcodeJoinDate' + key] = _this.orgJoinDate
            _this.dataForm['jobcodeLeaveDate' + key] = _this.dataForm.jobcodeLeaveDate
            this.partTimeJobCodeContentChange(el, key, num)

          /*
          // 先判断兼职网点与主职网点是否相同
          // 先判断兼职职位是否为空，空了就不判断重复
          if (_this.dataForm['partTimeJobcode' + key] === '' || _this.dataForm['partTimeJobcode' + key] === null) {
            _this.dataForm['jobcodeJoinDate' + key] = ''
            _this.dataForm['jobcodeLeaveDate' + key] = ''
            return false
          } else {
            // 判断是否与主职网点相同
            if (_this.dataForm['partTimeOutlet' + key] === _this.outletID) {
              // 当相同时，判断职位code是不是重复
              if (_this.dataForm['partTimeJobcode' + key] === _this.dataForm.jobCode) {
                _this.$alert(_this.$t('user.verificationparttime'), _this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                _this.dataForm['partTimeJobcode' + key] = ''
                _this.dataForm['jobcodeJoinDate' + key] = ''
                _this.dataForm['jobcodeLeaveDate' + key] = ''
                return false
              }
            }
            // 判断两个兼职网点是否相同
            if (_this.dataForm.partTimeOutletOne === _this.dataForm.partTimeOutletTwo) {
              if (_this.dataForm.partTimeJobcodeOne === _this.dataForm.partTimeJobcodeTwo) {
                _this.$alert(this.$t('user.verificationparttime'), _this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                _this.dataForm['partTimeJobcode' + key] = ''
                _this.dataForm['jobcodeJoinDate' + key] = ''
                _this.dataForm['jobcodeLeaveDate' + key] = ''
                return false
              }
            }
            _this.dataForm['jobcodeJoinDate' + key] = _this.orgJoinDate
            _this.dataForm['jobcodeLeaveDate' + key] = _this.dataForm.jobcodeLeaveDate
            this.partTimeJobCodeContentChange(el, key, num)
          }
          */
        }
      }).catch((err) => {
        console.log(err)
        _this.isDisable = false
      })
    },
    // 加入职位日期等于加入公司日期
    orgJoinDateabled() {
      if (this.leaveAndJoinLeaveDate !== '' && this.dataForm.orgJoinDate <= this.leaveAndJoinLeaveDate) {
        this.$alert(this.$t('user.leaveDateError', { 'handle': Vue.filter('formatDateNoTime')(this.leaveAndJoinLeaveDate) }), this.$t('prompt.title')).then(() => {
          this.dataForm.orgJoinDate = ''
        }).catch((err) => {
          console.log(err)
        })
        return false
      }
      this.orgJoinDate = this.dataForm.orgJoinDate
      this.dataForm.jobcodeJoinDate = this.dataForm.orgJoinDate
      if (this.dataForm.partTimeJobcodeOne !== null && this.dataForm.partTimeJobcodeOne !== '' && this.dataForm.partTimeJobcodeOne !== undefined) {
        this.dataForm.jobcodeJoinDateOne = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDateOne = ''
      }
      if (this.dataForm.partTimeJobcodeTwo !== null && this.dataForm.partTimeJobcodeTwo !== '' && this.dataForm.partTimeJobcodeTwo !== undefined) {
        this.dataForm.jobcodeJoinDateTwo = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDateTwo = ''
      }
      if (this.dataForm.partTimeJobcodeThree !== null && this.dataForm.partTimeJobcodeThree !== '' && this.dataForm.partTimeJobcodeThree !== undefined) {
        this.dataForm.jobcodeJoinDateThree = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDateThree = ''
      }
      if (this.dataForm.partTimeJobcodeFour !== null && this.dataForm.partTimeJobcodeFour !== '' && this.dataForm.partTimeJobcodeFour !== undefined) {
        this.dataForm.jobcodeJoinDateFour = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDateFour = ''
      }
      if (this.dataForm.partTimeJobcodeFive !== null && this.dataForm.partTimeJobcodeFive !== '' && this.dataForm.partTimeJobcodeFive !== undefined) {
        this.dataForm.jobcodeJoinDateFive = this.dataForm.orgJoinDate
      } else {
        this.dataForm.jobcodeJoinDateFive = ''
      }
      if (this.dataForm.orgJoinDate === '' || this.dataForm.orgJoinDate === null || this.dataForm.orgJoinDate === undefined) {
        this.$refs.dataForm.clearValidate('orgJoinDate')
      }
    },
    // 离职日期等于离开职位日期
    leaveDateabled() {
      this.dataForm.jobcodeLeaveDate = this.dataForm.leaveDate
      this.dataForm.jobcodeJoinDate = this.jianzhiorgJoinDate
      if (this.dataForm.partTimeJobcodeOne !== null && this.dataForm.partTimeJobcodeOne !== '' && this.dataForm.partTimeJobcodeOne !== undefined) {
        this.dataForm.jobcodeLeaveDateOne = this.dataForm.jobcodeLeaveDate
        this.dataForm.jobcodeJoinDateOne = this.jianzhiorgJoinDate
      } else {
        this.dataForm.jobcodeLeaveDateOne = ''
        this.dataForm.jobcodeJoinDateOne = ''
      }
      if (this.dataForm.partTimeJobcodeTwo !== null && this.dataForm.partTimeJobcodeTwo !== '' && this.dataForm.partTimeJobcodeTwo !== undefined) {
        this.dataForm.jobcodeLeaveDateTwo = this.dataForm.jobcodeLeaveDate
        this.dataForm.jobcodeJoinDateTwo = this.jianzhiorgJoinDate
      } else {
        this.dataForm.jobcodeLeaveDateTwo = ''
        this.dataForm.jobcodeJoinDateTwo = ''
      }
      if (this.dataForm.partTimeJobcodeThree !== null && this.dataForm.partTimeJobcodeThree !== '' && this.dataForm.partTimeJobcodeThree !== undefined) {
        this.dataForm.jobcodeLeaveDateThree = this.dataForm.jobcodeLeaveDate
        this.dataForm.jobcodeJoinDateThree = this.jianzhiorgJoinDate
      } else {
        this.dataForm.jobcodeLeaveDateThree = ''
        this.dataForm.jobcodeJoinDateThree = ''
      }
      if (this.dataForm.partTimeJobcodeFour !== null && this.dataForm.partTimeJobcodeFour !== '' && this.dataForm.partTimeJobcodeFour !== undefined) {
        this.dataForm.jobcodeLeaveDateFour = this.dataForm.jobcodeLeaveDate
        this.dataForm.jobcodeJoinDatefFour = this.jianzhiorgJoinDate
      } else {
        this.dataForm.jobcodeLeaveDateFour = ''
        this.dataForm.jobcodeJoinDatefFour = ''
      }
      if (this.dataForm.partTimeJobcodeFive !== null && this.dataForm.partTimeJobcodeFive !== '' && this.dataForm.partTimeJobcodeFive !== undefined) {
        this.dataForm.jobcodeLeaveDateFive = this.dataForm.jobcodeLeaveDate
        this.dataForm.jobcodeJoinDatefFive = this.jianzhiorgJoinDate
      } else {
        this.dataForm.jobcodeLeaveDateFive = ''
        this.dataForm.jobcodeJoinDatefFive = ''
      }
      if (this.dataForm.leaveDate === '' || this.dataForm.leaveDate === null || this.dataForm.leaveDate === undefined) {
        this.$refs.dataForm.clearValidate('leaveDate')
      }
    },
    // 选取兼职网点时
    partOrgChange(orgId, index) {
      if (index === 0) {
        this.jobCodeNumOne = this.$t('activiti.jobCodeNum')
        this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      } else if (index === 1) {
        this.jobCodeNumTwo = this.$t('activiti.jobCodeNum')
        this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      }else if (index === 2) {
        this.jobCodeNumThree = this.$t('activiti.jobCodeNum')
        this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      }else if (index === 3) {
        this.jobCodeNumFour = this.$t('activiti.jobCodeNum')
        this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      }else if (index === 4) {
        this.jobCodeNumFive = this.$t('activiti.jobCodeNum')
        this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      }
      if (orgId !== '' && orgId !== undefined && orgId !== null) {
        this['parttimeShow' + index] = false
        this.$request.post('/sys/commuser/commPositionTimeJob',
          {
            positionCode: this.dataForm.jobCode,
            orgId: orgId,
            positionName: ''
          }).then((res, total, code, data) => {
            if (res && res.length < 1) {
              this.$alert(this.$t('user.hasNoPartTime'), this.$t('prompt.title')).then(() => {
                if (index === 0) {
                  this.dataForm.partTimeOutletOne = ''
                }
                if (index === 1) {
                  this.dataForm.partTimeOutletTwo = ''
                }
                if (index === 2) {
                  this.dataForm.partTimeOutletThree = ''
                }
                if (index === 3) {
                  this.dataForm.partTimeOutletFour = ''
                }
                if (index === 4) {
                  this.dataForm.partTimeOutletFive = ''
                }
              }).catch((err) => {
                console.log(err)
              })
            }
            this['parttimejobList' + index] = res
          }).catch((err) => {
            console.log(err)
          })
      } else {
        this['parttimeShow' + index] = true
      }
      if (index === 0) {
        this.dataForm.partTimeJobcodeOne = ''
        this.dataForm.jobcodeJoinDateOne = ''
      }
      if (index === 1) {
        this.dataForm.partTimeJobcodeTwo = ''
        this.dataForm.jobcodeJoinDateTwo = ''
      }
      if (index === 2) {
        this.dataForm.partTimeJobcodeThree = ''
        this.dataForm.jobcodeJoinDateThree = ''
      }
      if (index === 3) {
        this.dataForm.partTimeJobcodeFour = ''
        this.dataForm.jobcodeJoinDateFour = ''
      }
      if (index === 4) {
        this.dataForm.partTimeJobcodeFive = ''
        this.dataForm.jobcodeJoinDateFive = ''
      }
    },
    // 获取bbano等信息，获取经销商网点下直线上级
    orgIdCheck(el) {
      // 清空主要职位，兼职，直线经理，只保留一个兼职岗位显示在页面上
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
      this.jobCodeNumOne = this.$t('activiti.jobCodeNum')
      this.jobCodeNumTwo = this.$t('activiti.jobCodeNum')
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.dataForm.jobCode = ''
      this.parttimejobList0 = []
      this.parttimejobList1 = []
      this.parttimejobList2 = []
      this.parttimejobList3 = []
      this.parttimejobList4 = []
      this.dataForm.partTimeOutletOne = ''
      this.dataForm.partTimeOutletTwo = ''
      this.dataForm.partTimeJobcodeOne = ''
      this.dataForm.partTimeJobcodeTwo = ''
      this.dataForm.jobcodeJoinDate = ''
      this.dataForm.jobcodeJoinDateOne = ''
      this.dataForm.jobcodeLeaveDateOne = ''
      this.dataForm.partTimeJobcodeTwo = ''
      this.dataForm.jobcodeJoinDateTwo = ''
      this.dataForm.jobcodeLeaveDateTwo = ''
      this.partOrgShow = true
      this.parttimeShow0 = true
      this.parttimeShow1 = true
      this.parttimeShow2 = true
      this.parttimeShow3 = true
      this.parttimeShow4 = true
      // 切换网点清空职位信息，兼职信息
      if (el !== '' && el !== undefined && el !== null) {
        this.dataForm.jobCode = ''
        this.dataForm.jobcodeJoinDate = ''
        this.dataForm.jobcodeLeaveDate = ''
        this.dataForm.partTimeJobcodeOne = ''
        this.parttimeCheckedList = [null, null, null, null]
        this.addshow = true
        this.deleteshow = false
        this.jobCodeshow = true
        this.querySearchPart0('')
        this.querySearchPart1('')
        this.querySearchPart2('')
        this.querySearchPart3('')
        this.querySearchPart4('')
      } else {
        // 如果网点空了，主值不可选
        this.jobCodeshow = false
        this.dataForm.bbaNo = ''
        this.dataForm.nscNo = ''
        this.dataForm.brandCode = ''
        this.dataForm.outletType = ''
      }
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate('jobCode')
      })
      for (let i = 0; i < this.results.length; i++) {
        if (el === this.results[i].orgId) {
          this.dataForm.bbaNo = this.results[i].bbaNo
          this.dataForm.nscNo = this.results[i].nscNo
          this.dataForm.outletType = Vue.filter('coverEnum')(this.results[i].networkType, 'networkType')
          this.dataForm.brandCode = Vue.filter('coverEnumList')(this.results[i].brandCodes, 'brandCode', ',')
        }
      }
      this.positionlist = []
      if (el !== null && el !== '') {
        this.$request.post('/sys/commuser/commPositionByParam',
          {
            orgType: '60',
            orgId: el,
            positionName: ''
          }
        ).then((res, total, code, data) => {
          this.positionlist = res
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.positionlist = []
      }
    },
    // 控制入职离职显示
    jobStatusabled() {
      if (this.dataForm.jobStatus === '10') {
        this.accessionDateshow = true
        this.leavedateshow = false
        this.joindateabled = false
        this.dataForm.jobcodeLeaveDate = ''
        this.dataForm.jobcodeLeaveDateOne = ''
        this.dataForm.jobcodeLeaveDateTwo = ''
        this.dataForm.jobcodeLeaveDateThree = ''
        this.dataForm.jobcodeLeaveDateFour = ''
      } else if (this.dataForm.jobStatus === '20') {
        this.leavedateshow = true
        this.accessionDateshow = true
      }
    },
    // 获取主要职位list
    queryMainPosition(queryString) {
      this.$request.post('/sys/commuser/commPositionByParam',
        {
          orgType: this.dataForm.orgType,
          orgId: this.outletID,
          positionName: queryString
        }
      ).then((res, total, code, data) => {
        this.positionlist = res
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取兼职1职位list
    queryJobPart0(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletOne,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList0 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职2职位list
    queryJobPart1(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletTwo,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList1 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职3职位list
    queryJobPart2(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletThree,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList2 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职4职位list
    queryJobPart3(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletFour,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList3 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职5职位list
    queryJobPart4(queryString) {
      this.$request.post('/sys/commuser/commPositionTimeJob',
        {
          orgId: this.dataForm.partTimeOutletFive,
          positionCode: this.dataForm.jobCode,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.parttimejobList4 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职网点list
    querySearchPart0(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.outletID,
          name: queryString
        }).then((res, total, code, data) => {
          this.partResults0 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职网点list
    querySearchPart1(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.outletID,
          name: queryString
        }).then((res, total, code, data) => {
          this.partResults1 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职网点list
    querySearchPart2(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.outletID,
          name: queryString
        }).then((res, total, code, data) => {
          this.partResults2 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职网点list
    querySearchPart3(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.outletID,
          name: queryString
        }).then((res, total, code, data) => {
          this.partResults3 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取兼职网点list
    querySearchPart4(queryString) {
      this.$request.post('/sys/commuser/queryPartOutlet',
        {
          orgId: this.outletID,
          name: queryString
        }).then((res, total, code, data) => {
          this.partResults4 = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取所属公司
    querySearchCompany(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          orgType: this.dataForm.orgType,
          name: queryString
        }).then((res, total, code, data) => {
          this.companyresults = res
        }).catch((err) => {
          console.log(err)
        })
    },
    // 获取网点list
    querySearch(queryString) {
      if (this.roleTypeVal === '0' || this.roleTypeVal === '1') {
        this.$request.get('/sys/org/selectOrg',
          {
            orgType: '60',
            name: queryString
          }
        ).then((res, total, code, data) => {
          this.results = res
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.$request.post('/sys/commuser/queryPartOutlet',
          {
            orgId: this.dataForm.orgId,
            name: queryString
          }).then((res, total, code, data) => {
            this.results = res
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    // 获取预留签约经销商
    orgquerySearch(queryString) {
      this.$request.get('/sys/org/selectOrg',
        {
          name: queryString,
          orgType: '50'
        }
      ).then((res, total, code, data) => {
        this.orgResulets = res.map(item => {
          item.orgId = item.orgId + ''
          item.name = item.name + ''
          return item
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // authType 10:Admin 20：普通用户 30：老师 40：管理层
    // orgType 10：合作伙伴 20：合作院校 30：BMW Group 40：Outlet
    // 切换版本
    handleClick(num) {
      let num1 = num.index
      if (num1 > 0) {
        this.historydataForm1 = JSON.parse(JSON.stringify(this.dataForm.userHistoryEntityList[num1 - 1]))
        this.historydataForm1.dealerShipId = this.historydataForm1.dealerShipId + ''
        if (this.historydataForm1.dealerShipId === 'null') {
          this.historydataForm1.dealerShipId = ''
        }
        if (this.historydataForm1.dealerShipId && this.dataForm.historydataForm1 !== '') {
          this.$request.get(`/sys/org/info/${this.historydataForm1.dealerShipId}`).then((res, total, code, data) => {
            this.orgResuletsHistory = []
            this.orgResuletsHistory.push(res)
          }).catch((err) => {
            console.log(err)
          })
        }
        // 赋值网点类型
        this.historydataForm1.outletType = Vue.filter('coverEnumList')(this.historydataForm1.networkType, 'networkType', ',')
        if (!this.dataForm.userHistoryEntityList[num1 - 1].headurl || this.dataForm.userHistoryEntityList[num1 - 1] === '') {
          this.historydataForm1.headurl = require('@/assets/img/default-image.png')
        } else {
          this.historydataForm1.headurl = this.dataForm.uploadHost + this.dataForm.userHistoryEntityList[num1 - 1].headurl
        }
        if (this.dataForm.userHistoryEntityList[num1 - 1].privacyFileUrl && this.dataForm.userHistoryEntityList[num1 - 1].privacyFileUrl !== '') {
          this.privacyFileUrlHistory = this.dataForm.uploadHost + this.dataForm.userHistoryEntityList[num1 - 1].privacyFileUrl
        } else {
          this.privacyFileUrlHistory = ''
        }
        this.headDateHistory = this.$t('user.headDate1') + this.historydataForm1.versionStartTime + this.$t('user.headDate2') + this.historydataForm1.versionEndTime
        // 获取角色
        this.$request.get(`/sys/commuser/sysRoleMT`,
          {
            orgType: this.historydataForm1.orgType,
            authType: this.historydataForm1.authType
          }
        ).then((res, total, code, data) => {
          this.historyrolelist = data.result
          this.historyrolelist = res.map(item => {
            item.roleId = item.roleId + ''
            return item
          })
        }).catch((err) => {
          console.log(err)
        })
        this.historydataForm1.bmwSeniority = (this.historydataForm1.bmwSeniority / 365).toFixed(2)
        // 特殊情况，自己国际化

        if (this.dataForm.orgType === '60') {
          this.historyjobCodeNumOne = this.$t('activiti.jobCodeNum')
          this.historyjobCodeNumTwo = this.$t('activiti.jobCodeNum')
          this.historyjobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          this.historyjobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          if (this.historydataForm1.partTimeJobcodeOne && this.historydataForm1.partTimeJobcodeOne !== '') {
            // 兼职1网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                status: '20',
                orgId: this.historydataForm1.partTimeOutletOne,
                orgType: this.historydataForm1.orgType
              }
            ).then((res, total, code, data) => {
              this.historyPartResults0 = res
            }).catch((err) => {
              console.log(err)
            })

            // 兼职1职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                status: '20',
                positionCode: this.historydataForm1.partTimeJobcodeOne + ''
              }).then((res, total, code, data) => {
                this.historyParttimejobList0 = res
                this.historyjobCodeNumOne = this.$t('activiti.jobCodeNum') + res[0].positionCode
                if (res[0].positionDesc) {
                  this.historyjobCodeContentOne = this.historyjobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                } else {
                  this.historyjobCodeContentOne = this.historyjobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
                }
              }).catch((err) => {
                console.log(err)
              })
          }
          if (this.historydataForm1.partTimeJobcodeTwo && this.historydataForm1.partTimeJobcodeTwo !== '') {
            // 兼职2网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                status: '20',
                orgId: this.historydataForm1.partTimeOutletTwo,
                orgType: this.historydataForm1.orgType
              }
            ).then((res, total, code, data) => {
              this.historyPartResults1 = res
            }).catch((err) => {
              console.log(err)
            })

            // 兼职2职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                status: '20',
                positionCode: this.historydataForm1.partTimeJobcodeTwo + ''
              }).then((res, total, code, data) => {
                this.historyParttimejobList1 = res
                this.historyjobCodeNumTwo = this.$t('activiti.jobCodeNum') + res[0].positionCode
                if (res[0].positionDesc) {
                  this.historyjobCodeContentTwo = this.historyjobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                } else {
                  this.historyjobCodeContentTwo = this.historyjobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
                }
              }).catch((err) => {
                console.log(err)
              })
          }
          if (this.historydataForm1.partTimeJobcodeThree && this.historydataForm1.partTimeJobcodeThree !== '') {
            // 兼职3网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                status: '20',
                orgId: this.historydataForm1.partTimeOutletThree,
                orgType: this.historydataForm1.orgType
              }
            ).then((res, total, code, data) => {
              this.historyPartResults2 = res
            }).catch((err) => {
              console.log(err)
            })

            // 兼职3职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                status: '20',
                positionCode: this.historydataForm1.partTimeJobcodeThree + ''
              }).then((res, total, code, data) => {
                this.historyParttimejobList2 = res
                this.historyjobCodeNumThree = this.$t('activiti.jobCodeNum') + res[0].positionCode
                if (res[0].positionDesc) {
                  this.historyjobCodeContentThree = this.historyjobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                } else {
                  this.historyjobCodeContentThree = this.historyjobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
                }
              }).catch((err) => {
                console.log(err)
              })
          }
          if (this.historydataForm1.partTimeJobcodeFour && this.historydataForm1.partTimeJobcodeFour !== '') {
            // 兼职4网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                status: '20',
                orgId: this.historydataForm1.partTimeOutletFour,
                orgType: this.historydataForm1.orgType
              }
            ).then((res, total, code, data) => {
              this.historyPartResults3 = res
            }).catch((err) => {
              console.log(err)
            })

            // 兼职4职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                status: '20',
                positionCode: this.historydataForm1.partTimeJobcodeFour + ''
              }).then((res, total, code, data) => {
                this.historyParttimejobList3 = res
                this.historyjobCodeNumFour = this.$t('activiti.jobCodeNum') + res[0].positionCode
                if (res[0].positionDesc) {
                  this.historyjobCodeContentFour = this.historyjobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                } else {
                  this.historyjobCodeContentFour = this.historyjobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
                }
              }).catch((err) => {
                console.log(err)
              })
          }
          if (this.historydataForm1.partTimeJobcodeFive && this.historydataForm1.partTimeJobcodeFive !== '') {
            // 兼职5网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                status: '20',
                orgId: this.historydataForm1.partTimeOutletFive,
                orgType: this.historydataForm1.orgType
              }
            ).then((res, total, code, data) => {
              this.historyPartResults4 = res
            }).catch((err) => {
              console.log(err)
            })

            // 兼职5职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                status: '20',
                positionCode: this.historydataForm1.partTimeJobcodeFive + ''
              }).then((res, total, code, data) => {
                this.historyParttimejobList4 = res
                this.historyjobCodeNumFive = this.$t('activiti.jobCodeNum') + res[0].positionCode
                if (res[0].positionDesc) {
                  this.historyjobCodeContentFive = this.historyjobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
                } else {
                  this.historyjobCodeContentFive = this.historyjobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
                }
              }).catch((err) => {
                console.log(err)
              })
          }
          if (this.historydataForm1.partTimeJobcodeOne) {
            this.historypartTimeJobCodeContentChange(this.historydataForm1.partTimeJobcodeOne, 'One', 0)
          }
          if (this.historydataForm1.partTimeJobcodeTwo) {
            this.historypartTimeJobCodeContentChange(this.historydataForm1.partTimeJobcodeTwo, 'Two', 1)
          }
          if (this.historydataForm1.partTimeJobcodeThree) {
            this.historypartTimeJobCodeContentChange(this.historydataForm1.partTimeJobcodeThree, 'Three', 2)
          }
          if (this.historydataForm1.partTimeJobcodeFour) {
            this.historypartTimeJobCodeContentChange(this.historydataForm1.partTimeJobcodeFour, 'Four', 3)
          }
          if (this.historydataForm1.partTimeJobcodeFive) {
            this.historypartTimeJobCodeContentChange(this.historydataForm1.partTimeJobcodeFive, 'Five', 4)
          }
        }
        if (this.historydataForm1.orgId === 'null') {
          this.historydataForm1.orgId = ''
        }
        //this.$request.get('/sys/org/selectOrgByParam',
        this.$request.get('/sys/org/queryOrgForUserViewAndEdit',
          {
            orgId: this.historydataForm1.orgId,
            orgType: this.historydataForm1.orgType
          }
        ).then((res, total, code, data) => {
          // 经销商时需要回显品牌
          if (this.historydataForm1.orgType === '60') {
            var brandCodes = res[0].brandCodes
            this.historydataForm1.brandCode = Vue.filter('coverEnumList')(brandCodes, 'brandCode', ',')
            this.historyResults = res
          } else {
            this.historycompanyresults = res
          }
        }).catch((err) => {
          console.log(err)
        })
        // 根据jobCode回显主职
        if (this.historydataForm1.jobCode && this.historydataForm1.jobCode !== '') {
          this.$request.get('/sys/commuser/selectPositionByCode',
            {
              positionCode: this.historydataForm1.jobCode
            }).then((res, total, code, data) => {
              this.historyPositionlist = res
              if (this.historydataForm1.jobCode === '' || this.historydataForm1.jobCode === undefined || this.historydataForm1.jobCode === null) {
                this.historyjobCodeNum = this.$t('activiti.jobCodeNum')
                this.historyjobCodeContent = this.$t('activiti.jobCodeContent')
              } else {
                this.historyjobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
                if (res[0].positionDesc) {
                  this.historyjobCodeContent = this.$t('activiti.jobCodeContent') + res[0].positionDesc
                } else {
                  this.historyjobCodeContent = this.$t('activiti.jobCodeContent')
                }
              }
            }).catch((err) => {
              console.log(err)
            })
        }
        if (this.historydataForm1.orgType === ORG_TYPE_BMWG) {
          this.groupshow = true
          this.partnershow = false
          this.companyshow = false
          this.outGroupShow = false
          this.orgType = ORG_TYPE_BMWG
        } else if (this.historydataForm1.orgType === ORG_PARTANER || this.historydataForm1.orgType === ORG_SCHOOL) {
          this.groupshow = false
          this.partnershow = true
          this.companyshow = false
          this.outGroupShow = false
        } else if (this.historydataForm1.orgType === ORG_OUTLED) {
          this.companyshow = true
          this.partnershow = false
          this.groupshow = false
          this.outGroupShow = false
          this.orgType = ORG_OUTLED
        } else if (this.historydataForm1.orgType === ORG_GROUP) {
          this.companyshow = false
          this.partnershow = false
          this.groupshow = false
          this.outGroupShow = true
          this.orgType = ORG_GROUP
        }
        if (this.historydataForm1.jobStatus === '10') {
          this.accessionDateshow = true
          this.leavedateshow = false
        } else if (this.historydataForm1.jobStatus === '20') {
          this.leavedateshow = true
          this.accessionDateshow = true
        }
        if (this.historydataForm1.authType === AUTHTYPE_BESTSTUDENT && this.orgType === ORG_SCHOOL) {
          this.studentshow = true
          this.teachershow = false
        } else if (this.historydataForm1.authType === AUTHTYPE_TEACHER && this.orgType === ORG_SCHOOL) {
          this.studentshow = false
          // this.teachershow = true
          this.teachershow = false
        } else if (this.historydataForm1.authType === AUTHTYPE_TEACHER && this.orgType === ORG_TYPE_BMWG) {
          this.studentshow = false
          // this.teachershow = true
          this.teachershow = false
        } else if (this.historydataForm1.authType === AUTHTYPE_TEACHER && this.orgType === ORG_PARTANER) {
          this.studentshow = false
          // this.teachershow = true
          this.teachershow = false
        } else if (this.historydataForm1.authType === AUTHTYPE_USER && this.orgType === ORG_PARTANER) {
          this.studentshow = false
          this.teachershow = false
        } else if (this.historydataForm1.authType === AUTHTYPE_LAYER) {
          this.studentshow = false
          this.teachershow = false
        } else if (this.historydataForm1.authType === AUTHTYPE_ADMIN) {
          this.studentshow = false
          this.teachershow = false
        } else {
          this.studentshow = false
          this.teachershow = false
        }
        if (this.historydataForm1.orgType === ORG_PARTANER || this.historydataForm1.orgType === ORG_SCHOOL) {
          this.historypartnter = this.historydataForm1.orgId
        } else if (this.historydataForm1.orgType === ORG_TYPE_BMWG || this.historydataForm1.orgType === ORG_GROUP) {
          this.historybwmcompany = this.historydataForm1.orgId
        }
        // authType 10:Admin 20：普通用户 30：老师 40：管理层
        // orgType 10：合作伙伴 20：合作院校 30：BMW Group 40：Outlet
      } else {
        if (this.dataForm.jobStatus === '10') {
          this.accessionDateshow = true
          this.leavedateshow = false
        } else if (this.dataForm.jobStatus === '20') {
          this.leavedateshow = true
          this.accessionDateshow = true
        }
        if (this.dataForm.orgType === ORG_TYPE_BMWG) {
          this.groupshow = true
          this.partnershow = false
          this.companyshow = false
          this.outGroupShow = false
          this.orgType = ORG_TYPE_BMWG
        } else if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
          this.groupshow = false
          this.partnershow = true
          this.companyshow = false
          this.outGroupShow = false
          this.orgType = this.dataForm.orgType
        } else if (this.dataForm.orgType === ORG_GROUP) {
          this.groupshow = false
          this.outGroupShow = true
          this.partnershow = false
          this.companyshow = false
          this.orgType = this.dataForm.orgType
        } else if (this.dataForm.orgType === ORG_OUTLED) {
          this.$request.get('/sys/org/selectOrg',
            {
              orgType: '60',
              orgId: this.dataForm.orgId
            }
          ).then((res, total, code, data) => {
            this.result = res
            for (let i = 0; i < this.result.length; i++) {
              if (this.dataForm.orgId === this.result[i].orgId) {
                this.dataForm.brandCode = Vue.filter('coverEnumList')(this.result[i].brandCodes, 'brandCode', ',')
              }
            }
          }).catch((err) => {
            console.log(err)
          })
          this.companyshow = true
          this.partnershow = false
          this.groupshow = false
          this.outGroupShow = false
          this.orgType = ORG_OUTLED
        }
        if (this.dataForm.authType === AUTHTYPE_BESTSTUDENT && this.orgType === ORG_SCHOOL) {
          this.studentshow = true
          this.teachershow = false
        } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_SCHOOL) {
          this.studentshow = false
          this.teachershow = false
        } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_TYPE_BMWG) {
          this.studentshow = false
          // this.teachershow = true
          this.teachershow = false
        } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_PARTANER) {
          this.studentshow = false
          // this.teachershow = true
          this.teachershow = false
        } else if (this.dataForm.authType === AUTHTYPE_USER && this.orgType === ORG_PARTANER) {
          this.studentshow = false
          this.teachershow = false
        } else if (this.dataForm.authType === AUTHTYPE_LAYER) {
          this.studentshow = false
          this.teachershow = false
        } else if (this.dataForm.authType === AUTHTYPE_ADMIN) {
          this.studentshow = false
          this.teachershow = false
        }
      }
    },
    // 身份证
    idCard() {
      let value = this.dataForm.idcard
      if (this.dataForm.idType === '10') {
        if (value && (!(/\d{17}[\d|x]|\d{15}/).test(value) || (value.length !== 15 && value.length !== 18) || value.substring(6, 7) === '0' || value.substring(10, 12) > '12' || value.substring(10, 12) === '00' || value.substring(12, 14) > '31' || value.substring(12, 14) === '00')) {
          this.dataForm.birthday = ''
          this.dataForm.sexCode = ''
          return false
        }
        if (this.dataForm.idcard.length === 18) {
          this.dataForm.birthday = this.dataForm.idcard.substring(6, 10) + '-' + this.dataForm.idcard.substring(10, 12) + '-' + this.dataForm.idcard.substring(12, 14)
          if (this.dataForm.idcard.substring(16, 17) % 2 === 0) {
            this.dataForm.sexCode = '20'
          } else if (this.dataForm.idcard.substring(16, 17) % 2 === 1) {
            this.dataForm.sexCode = '10'
          }
        }
        let date1 = new Date(Date.parse(this.sysTime.replace(/-/g, '/')))
        let today = this.dataForm.birthday
        today = today.split('/')
        let year = date1.getFullYear()
        let month = date1.getMonth() + 1
        let day = date1.getDate()
        if ((year - today[0]) < 14 || (year - today[0]) > 71) {
          this.dataForm.sexCode = ''
          this.dataForm.birthday = ''
          return false
        } else if ((year - today[0]) === 14) {
          if ((month - today[1]) < 0) {
            this.dataForm.sexCode = ''
            this.dataForm.birthday = ''
            return false
          } else if ((month - today[1]) === 0) {
            if ((day - today[2]) < 0) {
              this.dataForm.sexCode = ''
              this.dataForm.birthday = ''
              return false
            }
          }
        } else if ((year - today[0]) === 71) {
          if ((month - today[1]) > 0) {
            this.dataForm.sexCode = ''
            this.dataForm.birthday = ''
            return false
          } else if ((month - today[1]) === 0) {
            if ((day - today[2]) >= 0) {
              this.dataForm.sexCode = ''
              this.dataForm.birthday = ''
              return false
            }
          }
        }
      }
      var checkFlag = false
      if (this.dataForm.idType === '10' && value && !(!(/\d{17}[\d|x]|\d{15}/).test(value) || (value.length !== 15 && value.length !== 18) || value.substring(6, 7) === '0' || value.substring(10, 12) > '12' || value.substring(12, 14) > '31')) {
        checkFlag = true
      }
      if (this.dataForm.idType === '20' && value && (/^[a-zA-Z0-9]{7,11}$/).test(value)) {
        checkFlag = true
      }
      if (checkFlag) {
        this.$request.get(`/sys/commuser/checkIdCard/`, {
          idCard: this.dataForm.idcard,
          idType: this.dataForm.idType
        }).then((res, total, code, data) => {
          // 如果有并且活动，提示他重复了
          if (res && res.jobStatus === '10') {
            if (res.registrationApprovaStatus === '50') {
              this.$alert(this.$t('user.hasRegist50'), this.$t('prompt.title')).then((res) => {
                console.log(res)
              }).catch((err) => {
                console.log(err)
              })
              return false
            } else {
              // if (res.registrationApprovaStatus === '20') {
              if (res.registrationApprovaStatus === null) {
              } else {
                this.$alert(this.$t('user.hasRegist'), this.$t('prompt.title')).then((res) => {
                  console.log(res)
                }).catch((err) => {
                  console.log(err)
                })
                return false
              }
            }
          }
          // 如果有并且不活动，提示他是否进入修改
          if (res && (res.jobStatus === '20' || (res.jobStatus === '10' && res.registrationApprovaStatus === null))) {
            // if (res && res.jobStatus === '20') {
            if (this.dataForm.agreePolicy === '20') {
              this.dataForm.mobile = ''
              this.dataForm.idcard = ''
              // 任何情况下 清空最高学历都设置为其他 20220317
              this.dataForm.educationCode = '70'
              if (this.dataForm.idType === '10') {
                this.dataForm.birthday = this.dataForm.idcard.substring(6, 10) + '-' + this.dataForm.idcard.substring(10, 12) + '-' + this.dataForm.idcard.substring(12, 14)
              } else {
                this.dataForm.birthday = ''
              }
            }
            this.leaveAndJoinFlag = true
            this.headModifyShow = true
            this.leave = '20'
            // this.leaveAndJoinLeaveDate = res.leaveDate
            this.dataForm.historyFlg = '1'
            this.dataForm.updateMode = 'REENTRY'
            for (var key in this.leaveAndJoinForm) {
              this.leaveAndJoinForm[key] = res[key]
            }
            // TODO 存在隐形bug 日期框无法自动关闭，disable设置时机存在问题
            this.leaveAndJoinDisabled = true
            this.leaveAndJoinForm.loginFlag = '10'

            const base64url = require('base64-url')
            let aes = new AesUtil()
            let userId = base64url.encode(aes.encrypt(res.userId + ''))

            this.$request.get(`/sys/commuser/infomt/${userId}`).then((res, total, code, data) => {
              this.leaveAndJoinForm.leaveDate = res.leaveDate
              this.leaveAndJoinLeaveDate = res.leaveDate
            }).catch((err) => {
              console.log(err)
            })
            this.dataForm.jobStatus = '10'
            this.initData(this.leaveAndJoinForm)
            this.dataForm.leaveDate = ''
            // 清除所有离职日期
            this.dataForm.jobcodeLeaveDate = ''
            this.dataForm.jobcodeLeaveDateOne = ''
            this.dataForm.jobcodeLeaveDateTwo = ''
            // 清除岗龄
            this.dataForm.jobcodeAge = 0
            // 打开职位相关
            this.outletIDshow = false
            // this.jobCodeshow = true
            this.partTimejobCodeOneshow = false
            this.partTimejobCodeTwoshow = false
            this.partTimejobCodeThreeshow = false
            this.partTimejobCodeFourshow = false
            this.partTimejobCodeFiveshow = false
            this.leavedateshow = false
            this.accessionDateshow = true
            // }).catch(() => { })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      this.$refs.dataForm.clearValidate('idcard')
      this.$refs.dataForm.clearValidate('birthday')
      this.$refs.dataForm.clearValidate('sexCode')
    },
    // 身份类型
    idTypeChange(value) {
      if (value === '20') {
        this.placeBirthday = this.$t('user.selectBirthday')
        this.placeSex = this.$t('user.selectSex')
      } else if (value === '10') {
        this.placeBirthday = this.$t('organization.orgCodeMessage')
        this.placeSex = this.$t('organization.orgCodeMessage')
        this.dataForm.birthday = ''
        this.dataForm.sexCode = ''
      }
      this.dataForm.idcard = ''
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate('birthday')
        this.$refs.dataForm.clearValidate('sexCode')
        this.$refs.dataForm.clearValidate('idcard')
      })
    },
    // authType 10:Admin 20：普通用户 30：老师 40：管理层
    // orgType 10：合作伙伴 20：合作院校 30：BMW Group 40：Outlet
    changeOrgType(val) {
      this.perClassification = this.newperClassification
      this.dataForm.authType = ''
      // if (this.dataForm.orgType === '' || this.dataForm.orgType === null) {
      this.jobCodeshow = false
      this.partnter = ''
      this.dataForm.jobCode = ''
      this.outletID = ''
      this.bmwgroup = ''
      this.outGroup = ''
      this.dataForm.roleId = []
      this.orgIdCheck('')
      // }
      if (this.dataForm.orgType === ORG_PARTANER) {
        this.$request.get(`/sys/org/selectOrg`, {
          orgType: '20'        }).then((res, total, code, data) => {
          this.companyresults = res
        }).catch((err) => {
          console.log(err)
        })
      }
      if (this.dataForm.orgType === ORG_SCHOOL) {
        this.perClassification = this.oldperClassification
        this.$request.get(`/sys/org/selectOrg`, {
          orgType: '30'        }).then((res, total, code, data) => {
          this.companyresults = res
        }).catch((err) => {
          console.log(err)
        })
      }
      if (this.dataForm.orgType === ORG_TYPE_BMWG || this.dataForm.orgType === ORG_GROUP) {
        this.$request.get(`/sys/org/selectOrg`, {
          orgType: this.dataForm.orgType        }).then((res, total, code, data) => {
          this.companyresults = res
        }).catch((err) => {
          console.log(err)
        })
      }
      this.studentshow = false
      this.teachershow = false
      if (this.dataForm.orgType === ORG_TYPE_BMWG) {
        this.groupshow = true
        this.outGroupShow = false
        this.partnershow = false
        this.companyshow = false
        this.orgType = ORG_TYPE_BMWG
      }
      if (this.dataForm.orgType === ORG_GROUP) {
        this.outGroupShow = true
        this.groupshow = false
        this.partnershow = false
        this.companyshow = false
        this.orgType = ORG_GROUP
      }
      if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
        this.outGroupShow = false
        this.groupshow = false
        this.partnershow = true
        this.companyshow = false
        this.orgType = this.dataForm.orgType
      }
      if (this.dataForm.orgType === ORG_OUTLED) {
        if (this.roleTypeVal === '0' || this.roleTypeVal === '1') {
          this.$request.get('/sys/org/selectOrg',
            {
              orgType: '60'
            }
          ).then((res, total, code, data) => {
            this.results = res
          }).catch((err) => {
            console.log(err)
          })
        } else {
          console.warn(this.dataForm.orgId)
          this.$request.post('/sys/commuser/queryPartOutlet',
            {
              orgId: this.dataForm.orgId,
              name: ''
            }).then((res, total, code, data) => {
              this.results = res
            }).catch((err) => {
              console.log(err)
            })
        }
        this.companyshow = true
        this.outGroupShow = false
        this.partnershow = false
        this.groupshow = false
        this.orgType = ORG_OUTLED
      }
      this.studentshow = false
      if (this.dataForm.authType === AUTHTYPE_BESTSTUDENT && this.orgType === ORG_SCHOOL) {
        this.studentshow = true
      }
      if (this.dataForm.orgType === ORG_ALL) {
        this.groupshow = false
        this.partnershow = true
        this.outGroupShow = false
        this.companyshow = false
      }
      if (this.dataForm.authType !== '' && this.dataForm.authType !== null) {
        this.getDefaultRole()
      }
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate('outletID')
        this.$refs.dataForm.clearValidate('GWMcompany')
        this.$refs.dataForm.clearValidate('partnerCompany')
      })
    },
    // authType 10:Admin 20：普通用户 30：老师 40：管理层
    // orgType 10：合作伙伴 20：合作院校 30：BMW Group 40：Outlet
    changeAuthType(val) {
      this.$refs.dataForm.clearValidate('authType')
      this.dataForm.roleId = []
      // 获取角色信息
      this.$request.get(
        `/sys/commuser/sysRoleMT`,
        {
          orgType: this.dataForm.orgType,
          authType: val
        }
      ).then((res, total, code, data) => {
        this.rolelist = res.map(item => {
          item.roleId = item.roleId + ''
          return item
        })
      }).catch((err) => {
        console.log(err)
      })
      if (this.dataForm.orgType !== '' && this.dataForm.orgType !== null) {
        this.getDefaultRole()
      }
      this.studentshow = false
      this.teachershow = false
      if (this.dataForm.orgType === ORG_TYPE_BMWG) {
        this.outGroupShow = false
        this.groupshow = true
        this.partnershow = false
        this.companyshow = false
      } else if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
        this.groupshow = false
        this.outGroupShow = false
        this.partnershow = true
        this.companyshow = false
        this.orgType = this.dataForm.orgType
      } else if (this.dataForm.orgType === ORG_GROUP) {
        this.outGroupShow = true
        this.groupshow = false
        this.partnershow = false
        this.companyshow = false
        this.orgType = this.dataForm.orgType
      } else if (this.dataForm.orgType === ORG_OUTLED) {
        this.companyshow = true
        this.outGroupShow = false
        this.partnershow = false
        this.groupshow = false
      }
      if (this.dataForm.authType === AUTHTYPE_BESTSTUDENT && this.orgType === ORG_SCHOOL) {
        this.studentshow = true
        this.teachershow = false
      } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_SCHOOL) {
        this.studentshow = false
        // this.teachershow = true
        this.teachershow = false
      } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_TYPE_BMWG) {
        this.studentshow = false
        // this.teachershow = true
        this.teachershow = false
      } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_PARTANER) {
        this.studentshow = false
        // this.teachershow = true
        this.teachershow = false
      }
      if (this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)) {
        this.applyShow = this.dataMap.get('APPLY_ORG_TYPE_' + this.dataForm.orgType)
      }
      this.$refs.dataForm.clearValidate('roleId')
    },
    getDefaultRole() {
      this.$request.post(
        '/sys/role/queryRoleByType',
        {
          orgType: this.dataForm.orgType,
          authType: this.dataForm.authType
        }
      ).then((res, total, code, data) => {
        this.dataForm.roleId = []
        for (let i = 0; i < res.length; i++) {
          this.dataForm.roleId.push(res[i].roleId + '')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 清除校验
    roledChenge() {
      if (this.dataForm.roled !== []) {
        this.$refs.dataForm.clearValidate('roleId')
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      //防止连续点击 2021-03-23
      // this.isDisable = true
      // setTimeout(() => {
      //   this.isDisable = false
      // }, 15000)
      // 校验
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          //this.isDisable = false
          return false
        }
        if (this.dataForm.headurl === require('@/assets/img/default-image.png')) {
          this.$alert(this.$t('user.headUrlNotNull'), this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
          this.isDisable = false
          return false
        }
        //隐私协议
        if (!this.dataForm.userId || this.dataForm.userId === '') {
          if (this.privacyChecked === false) {
            this.$alert(this.$t('validate.agreement'), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }
        }
        // 如果经销商网点
        if (this.dataForm.orgType === ORG_OUTLED) {
          // 兼职一网点不空切职位空，视为兼职1没填好
          if (
             (this.dataForm.partTimeOutletOne !== null && this.dataForm.partTimeOutletOne !== '') &&
              (this.dataForm.partTimeJobcodeOne === null || this.dataForm.partTimeJobcodeOne === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '1' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }
          // 兼职二网点不空切职位空，视为兼职2没填好
          if (
            (this.dataForm.partTimeOutletTwo !== null && this.dataForm.partTimeOutletTwo !== '') &&
            (this.dataForm.partTimeJobcodeTwo === null || this.dataForm.partTimeJobcodeTwo === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '2' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }
          // 兼职三网点不空切职位空，视为兼职3没填好
          if (
            (this.dataForm.partTimeOutletThree !== null && this.dataForm.partTimeOutletThree !== '') &&
            (this.dataForm.partTimeJobcodeThree === null || this.dataForm.partTimeJobcodeThree === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '3' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }
          // 兼职四网点不空切职位空，视为兼职4没填好
          if (
            (this.dataForm.partTimeOutletFour !== null && this.dataForm.partTimeOutletFour !== '') &&
            (this.dataForm.partTimeJobcodeFour === null || this.dataForm.partTimeJobcodeFour === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '4' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }
          // 兼职五网点不空切职位空，视为兼职5没填好
          if (
            (this.dataForm.partTimeOutletFive !== null && this.dataForm.partTimeOutletFive !== '') &&
            (this.dataForm.partTimeJobcodeFive === null || this.dataForm.partTimeJobcodeFive === '')
          ) {
            this.$alert(this.$t('user.parttimeNotNull', { 'handle': '5' }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }

          //判断最后一个有值的兼职之前是否有空兼职
          let partTimeOutlets = [this.dataForm.partTimeOutletOne,this.dataForm.partTimeOutletTwo,this.dataForm.partTimeOutletThree,this.dataForm.partTimeOutletFour,this.dataForm.partTimeOutletFive]
          let leftPartTimeOutletIdx = -1
          let rightPartTimeOutletIdx = -1
          let leftStop = false

          //查找从左最后有值和从右最后有值的位置
          partTimeOutlets.forEach((el,idx)=> el ? leftStop ? rightPartTimeOutletIdx = idx : leftPartTimeOutletIdx = rightPartTimeOutletIdx = idx : leftStop = true)

          //判断逻辑
          //1、从所有兼职中是否找到值(有兼职才进行后继判断)
          //2、首次有值与最后有值的位置相同时不进行提示（表示中间没有空的兼职）
          if(leftPartTimeOutletIdx!=-1&&leftPartTimeOutletIdx!=rightPartTimeOutletIdx){
             this.$alert(this.$t('user.parttimeNotNull', { 'handle': leftPartTimeOutletIdx+2 }), this.$t('prompt.title')).then((res) => {
              console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            this.isDisable = false
            return false
          }

        }
        if (this.dataForm.jobStatus === '10') {
          this.dataForm.leaveDate = ''
        } else if (this.dataForm.jobStatus === '20') {
          this.dataForm.orgJoinDate = ''
        }
        if (this.dataForm.jobStatus === '20') {
          this.dataForm.historyFlg = '0'
        }
        // 增加版本
        if (this.dataForm.jobStatus === '10') {
          if (this.leave === '20') {
            this.dataForm.historyFlg = '1'
          }
        }
        // 组织类型为合作伙伴权限分类为Admin,组织类型为合作伙伴权限分类为普通用户,组织类型为合作伙伴权限分类为管理层,组织类型为合作院校权限分类为Admin,组织类型为合作院校权限分类为管理层
        if ((this.dataForm.orgType === ORG_PARTANER && this.dataForm.authType === AUTHTYPE_ADMIN) || (this.dataForm.orgType === ORG_PARTANER && this.dataForm.authType === AUTHTYPE_USER) || (this.dataForm.orgType === ORG_PARTANER && this.dataForm.authType === AUTHTYPE_LAYER) || (this.dataForm.orgType === ORG_SCHOOL && this.dataForm.authType === AUTHTYPE_ADMIN) || (this.dataForm.orgType === ORG_SCHOOL && this.dataForm.authType === AUTHTYPE_LAYER)) {
          this.dataForm.networkJoinDate = ''
          this.dataForm.brandCode = ''
          this.dataForm.bbaNo = ''
          this.dataForm.nscNo = ''
          this.dataForm.outletType = ''
          this.dataForm.partTimeJobcodeOne = ''
          this.dataForm.jobcodeJoinDateOne = ''
          this.dataForm.jobcodeLeaveDateOne = ''
          this.dataForm.partTimeJobcodeTwo = ''
          this.dataForm.jobcodeJoinDateTwo = ''
          this.dataForm.jobcodeLeaveDateTwo = ''
          this.dataForm.partTimeJobcodeThree = ''
          this.dataForm.jobcodeJoinDateThree = ''
          this.dataForm.jobcodeLeaveDateThree = ''
          this.dataForm.partTimeJobcodeFour = ''
          this.dataForm.jobcodeJoinDateFour = ''
          this.dataForm.jobcodeLeaveDateFour = ''
          this.dataForm.partTimeJobcodeFive = ''
          this.dataForm.jobcodeJoinDateFive = ''
          this.dataForm.jobcodeLeaveDateFive = ''
          this.dataForm.directManager = ''
          this.dataForm.dealerShipId = ''
          this.dataForm.majorCode = ''
          this.dataForm.talentBankFlag = '20'
          this.dataForm.officialAccountFlag = ''
          this.dataForm.enterSchoolDate = ''
          this.dataForm.leaveSchoolDate = ''
          this.dataForm.graduateStatus = ''
          this.dataForm.teacherType = ''
          this.dataForm.trialEndDate = ''
          this.dataForm.teacherGroupCode = ''
          this.dataForm.teacherRole = ''
          this.dataForm.availabilityDate = ''
          this.dataForm.annualTrainingObj = ''
          this.dataForm.contractCode = ''
          this.dataForm.teacherGrade = ''
          this.dataForm.bmwDeptCode = ''
          // 组织类型为合作伙伴权限分类为老师,组织类型为合作院校权限分类为老师
        } else if ((this.dataForm.orgType === ORG_PARTANER && this.dataForm.authType === AUTHTYPE_TEACHER) || (this.dataForm.orgType === ORG_SCHOOL && this.dataForm.authType === AUTHTYPE_TEACHER)) {
          this.dataForm.networkJoinDate = ''
          this.dataForm.brandCode = ''
          this.dataForm.bbaNo = ''
          this.dataForm.nscNo = ''
          this.dataForm.outletType = ''
          this.dataForm.partTimeJobcodeOne = ''
          this.dataForm.jobcodeJoinDateOne = ''
          this.dataForm.jobcodeLeaveDateOne = ''
          this.dataForm.partTimeJobcodeTwo = ''
          this.dataForm.jobcodeJoinDateTwo = ''
          this.dataForm.jobcodeLeaveDateTwo = ''
          this.dataForm.partTimeJobcodeThree = ''
          this.dataForm.jobcodeJoinDateThree = ''
          this.dataForm.jobcodeLeaveDateThree = ''
          this.dataForm.partTimeJobcodeFour = ''
          this.dataForm.jobcodeJoinDateFour = ''
          this.dataForm.jobcodeLeaveDateFour = ''
          this.dataForm.partTimeJobcodeFive = ''
          this.dataForm.jobcodeJoinDateFive = ''
          this.dataForm.jobcodeLeaveDateFive = ''
          this.dataForm.directManager = ''
          this.dataForm.dealerShipId = ''
          this.dataForm.majorCode = ''
          this.dataForm.talentBankFlag = '20'
          this.dataForm.officialAccountFlag = ''
          this.dataForm.enterSchoolDate = ''
          this.dataForm.leaveSchoolDate = ''
          this.dataForm.graduateStatus = ''
          this.dataForm.bmwDeptCode = ''
          // 组织类型为合作院校权限分类为普通用户
        } else if (this.dataForm.orgType === ORG_SCHOOL && this.dataForm.authType === AUTHTYPE_USER) {
          this.dataForm.networkJoinDate = ''
          this.dataForm.brandCode = ''
          this.dataForm.bbaNo = ''
          this.dataForm.nscNo = ''
          this.dataForm.outletType = ''
          // this.dataForm.jobCode = ''
          // this.dataForm.jobcodeJoinDate = ''
          // this.dataForm.jobcodeLeaveDate = ''
          this.dataForm.partTimeJobcodeOne = ''
          this.dataForm.jobcodeLeaveDateOne = ''
          this.dataForm.jobcodeJoinDateOne = ''
          this.dataForm.partTimeJobcodeTwo = ''
          this.dataForm.jobcodeJoinDateTwo = ''
          this.dataForm.jobcodeLeaveDateTwo = ''
          this.dataForm.partTimeJobcodeThree = ''
          this.dataForm.jobcodeJoinDateThree = ''
          this.dataForm.jobcodeLeaveDateThree = ''
          this.dataForm.partTimeJobcodeFour = ''
          this.dataForm.jobcodeJoinDateFour = ''
          this.dataForm.jobcodeLeaveDateFour = ''
          this.dataForm.partTimeJobcodeFive = ''
          this.dataForm.jobcodeJoinDateFive = ''
          this.dataForm.jobcodeLeaveDateFive = ''
          this.dataForm.directManager = ''
          this.dataForm.teacherType = ''
          this.dataForm.trialEndDate = ''
          this.dataForm.teacherGroupCode = ''
          this.dataForm.teacherRole = ''
          this.dataForm.availabilityDate = ''
          this.dataForm.annualTrainingObj = ''
          this.dataForm.contractCode = ''
          this.dataForm.teacherGrade = ''
          this.dataForm.bmwDeptCode = ''
          // 组织类型为BMW GROUP权限分类为Admin,组织类型为BMW GROUP权限分类为普通用户,组织类型为BMW GROUP权限分类为管理层
        } else if ((this.dataForm.orgType === ORG_TYPE_BMWG && this.dataForm.authType === AUTHTYPE_ADMIN) || (this.dataForm.orgType === ORG_TYPE_BMWG && this.dataForm.authType === AUTHTYPE_USER) || (this.dataForm.orgType === ORG_TYPE_BMWG && this.dataForm.authType === AUTHTYPE_LAYER)) {
          this.dataForm.networkJoinDate = ''
          this.dataForm.brandCode = ''
          this.dataForm.bbaNo = ''
          this.dataForm.nscNo = ''
          this.dataForm.outletType = ''
          // this.dataForm.jobCode = ''
          // this.dataForm.jobcodeJoinDate = ''
          // this.dataForm.jobcodeLeaveDate = ''
          this.dataForm.partTimeJobcodeOne = ''
          this.dataForm.jobcodeLeaveDateOne = ''
          this.dataForm.jobcodeJoinDateOne = ''
          this.dataForm.partTimeJobcodeTwo = ''
          this.dataForm.jobcodeJoinDateTwo = ''
          this.dataForm.jobcodeLeaveDateTwo = ''
          this.dataForm.partTimeJobcodeThree = ''
          this.dataForm.jobcodeJoinDateThree = ''
          this.dataForm.jobcodeLeaveDateThree = ''
          this.dataForm.partTimeJobcodeFour = ''
          this.dataForm.jobcodeJoinDateFour = ''
          this.dataForm.jobcodeLeaveDateFour = ''
          this.dataForm.partTimeJobcodeFive = ''
          this.dataForm.jobcodeJoinDateFive = ''
          this.dataForm.jobcodeLeaveDateFive = ''
          this.dataForm.directManager = ''
          this.dataForm.dealerShipId = ''
          this.dataForm.majorCode = ''
          this.dataForm.talentBankFlag = '20'
          this.dataForm.officialAccountFlag = ''
          this.dataForm.enterSchoolDate = ''
          this.dataForm.leaveSchoolDate = ''
          this.dataForm.graduateStatus = ''
          this.dataForm.teacherType = ''
          this.dataForm.trialEndDate = ''
          this.dataForm.teacherGroupCode = ''
          this.dataForm.teacherRole = ''
          this.dataForm.availabilityDate = ''
          this.dataForm.annualTrainingObj = ''
          this.dataForm.contractCode = ''
          this.dataForm.teacherGrade = ''
          // 组织类型为BMW GROUP权限分类为老师
        } else if (this.dataForm.orgType === ORG_TYPE_BMWG && this.dataForm.authType === AUTHTYPE_TEACHER) {
          this.dataForm.networkJoinDate = ''
          this.dataForm.brandCode = ''
          this.dataForm.bbaNo = ''
          this.dataForm.nscNo = ''
          this.dataForm.outletType = ''
          // this.dataForm.jobCode = this.teacherjobCode
          // this.dataForm.jobcodeJoinDate = this.teacherjobCodeJoinDate
          // this.dataForm.jobcodeLeaveDate = this.teacherjobCodeLeaveDate
          this.dataForm.partTimeJobcodeOne = ''
          this.dataForm.jobcodeJoinDateOne = ''
          this.dataForm.jobcodeLeaveDateOne = ''
          this.dataForm.partTimeJobcodeTwo = ''
          this.dataForm.jobcodeJoinDateTwo = ''
          this.dataForm.jobcodeLeaveDateTwo = ''
          this.dataForm.partTimeJobcodeThree = ''
          this.dataForm.jobcodeJoinDateThree = ''
          this.dataForm.jobcodeLeaveDateThree = ''
          this.dataForm.partTimeJobcodeFour = ''
          this.dataForm.jobcodeJoinDateFour = ''
          this.dataForm.jobcodeLeaveDateFour = ''
          this.dataForm.partTimeJobcodeFive = ''
          this.dataForm.jobcodeJoinDateFive = ''
          this.dataForm.jobcodeLeaveDateFive = ''
          this.dataForm.directManager = ''
          this.dataForm.dealerShipId = ''
          this.dataForm.majorCode = ''
          this.dataForm.talentBankFlag = '20'
          this.dataForm.officialAccountFlag = ''
          this.dataForm.enterSchoolDate = ''
          this.dataForm.leaveSchoolDate = ''
          this.dataForm.graduateStatus = ''
          // 组织类型为outlet
        } else if (this.dataForm.orgType === ORG_OUTLED) {
          this.dataForm.dealerShipId = ''
          this.dataForm.majorCode = ''
          this.dataForm.talentBankFlag = '20'
          this.dataForm.officialAccountFlag = ''
          this.dataForm.enterSchoolDate = ''
          this.dataForm.leaveSchoolDate = ''
          this.dataForm.graduateStatus = ''
          this.dataForm.teacherType = ''
          this.dataForm.trialEndDate = ''
          this.dataForm.teacherGroupCode = ''
          this.dataForm.teacherRole = ''
          this.dataForm.availabilityDate = ''
          this.dataForm.annualTrainingObj = ''
          this.dataForm.contractCode = ''
          this.dataForm.teacherGrade = ''
          this.dataForm.bmwDeptCode = ''
        } else if (this.dataForm.orgType === ORG_ALL || this.historydataForm1.orgType === ORG_GROUP) {
          this.dataForm.networkJoinDate = ''
          this.dataForm.brandCode = ''
          this.dataForm.bbaNo = ''
          this.dataForm.nscNo = ''
          this.dataForm.outletType = ''
          // this.dataForm.jobCode = ''
          // this.dataForm.jobcodeJoinDate = ''
          // this.dataForm.jobcodeLeaveDate = ''
          this.dataForm.partTimeJobcodeOne = ''
          this.dataForm.jobcodeJoinDateOne = ''
          this.dataForm.jobcodeLeaveDateOne = ''
          this.dataForm.partTimeJobcodeTwo = ''
          this.dataForm.jobcodeJoinDateTwo = ''
          this.dataForm.jobcodeLeaveDateTwo = ''
          this.dataForm.partTimeJobcodeThree = ''
          this.dataForm.jobcodeJoinDateThree = ''
          this.dataForm.jobcodeLeaveDateThree = ''
          this.dataForm.partTimeJobcodeFour = ''
          this.dataForm.jobcodeJoinDateFour = ''
          this.dataForm.jobcodeLeaveDateFour = ''
          this.dataForm.partTimeJobcodeFive = ''
          this.dataForm.jobcodeJoinDateFive = ''
          this.dataForm.jobcodeLeaveDateFive = ''
          this.dataForm.directManager = ''
          this.dataForm.dealerShipId = ''
          this.dataForm.majorCode = ''
          this.dataForm.talentBankFlag = '20'
          this.dataForm.officialAccountFlag = ''
          this.dataForm.enterSchoolDate = ''
          this.dataForm.leaveSchoolDate = ''
          this.dataForm.graduateStatus = ''
          this.dataForm.teacherType = ''
          this.dataForm.trialEndDate = ''
          this.dataForm.teacherGroupCode = ''
          this.dataForm.teacherRole = ''
          this.dataForm.availabilityDate = ''
          this.dataForm.annualTrainingObj = ''
          this.dataForm.contractCode = ''
          this.dataForm.teacherGrade = ''
          this.dataForm.bmwDeptCode = ''
        }
        if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL || this.dataForm.orgType === ORG_ALL) {
          this.bmwgroup = ''
          this.outGroup = ''
          this.outletID = ''
          this.dataForm.orgId = this.partnter
        } else if (this.dataForm.orgType === ORG_GROUP) {
          this.bmwgroup = ''
          this.outletID = ''
          this.partnter = ''
          this.dataForm.orgId = this.outGroup
        } else if (this.dataForm.orgType === ORG_TYPE_BMWG) {
          this.partnter = ''
          this.outletID = ''
          this.outGroup = ''
          this.dataForm.orgId = this.bmwgroup
        } else if (this.dataForm.orgType === ORG_OUTLED) {
          this.dataForm.orgId = this.outletID
          this.partnter = ''
          this.bmwgroup = ''
          this.outGroup = ''
        } else {
          this.dataForm.orgId = ''
        }
        this.talentBankFlag = '20'
        let postDataForm = JSON.parse(JSON.stringify(this.dataForm))
        if (postDataForm.roleId !== '' && postDataForm.roleId !== null && postDataForm.roleId !== undefined && postDataForm.roleId instanceof Array) {
          postDataForm.roleId = postDataForm.roleId.join(',')
        }
        if (postDataForm.headurl && postDataForm.headurl.indexOf('data:image') > -1) {
          postDataForm.headurl = ''
        }
        postDataForm['bmwSeniority'] = null
        if (!this.dataForm.userId) {
          this.saved = true
        }
        this.isDisable = true
        this.$request.post(`/sys/commuser/${!this.dataForm.userId ? 'save' : 'update'}`,
          postDataForm
        ).then((res, total, code, data) => {
          this.isDisable = false
          if (code != 1) {
            this.$alert(data.msg, this.$t('prompt.title'))
            this.saved = false
            return false
          }
          if (this.dataForm.headurl !== '' && this.dataForm.headurl !== null && this.dataForm.headurl !== undefined) {
            if (this.headId === this.dataForm.userId) {
              this.userForm = this.getStorage(this.GLOBAL.USER_DATA)
              this.userForm.headurl = this.dataForm.headurl
              this.userForm.email = this.dataForm.email
              this.userForm.mobile = this.dataForm.mobile
              this.setStorage(this.GLOBAL.USER_DATA, this.userForm)
              this.$eventHub.$emit(this.GLOBAL.HEADER_IMG, '')
            }
          }
           let saveFlg = (!this.dataForm.userId) ? true: false
           if (saveFlg) {
              // 追加提示 2021-04-14
              this.$alert(this.$t('user.noticeFaceCheck'),  this.$t('prompt.title')).then((res) => {
                console.log(res)
              }).catch((err) => {
                console.log(err)
              })
            }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }
          })
        }).catch((err) => {
          this.isDisable = false
          console.log(err)
        })
      })
    }, 5000, { 'leading': true, 'trailing': false }),

    initData(data) {
      let _this = this
      this.dataForm = {
        ...this.dataForm,
        ...data
      }
      // 如果获取到的最高学历不存在那么设置为70：其他 20220317
      if(!this.dataForm.educationCode || this.dataForm.educationCode === undefined || this.dataForm.educationCode === ''){
        this.dataForm.educationCode = '70'
        console.info("最高学历不存在，设定为其他。")
      }
      this.headDate = this.$t('user.headDate1') + this.dataForm.versionStartTime + this.$t('user.headDate2') + '~'
      if (this.dataForm.jobStatus === '20' && this.dataForm.versionEndTime) {
        this.headDate = this.$t('user.headDate1') + this.dataForm.versionStartTime + this.$t('user.headDate2') + this.dataForm.versionEndTime
      }
      this.fileList = []
      this.agreePolicyDisable = false
      if (this.dataForm.agreePolicy === '20') {
        this.agreePolicyDisable = true
        // 任何情况下 最高学历清空都设置为其他 20220317
        this.dataForm.educationCode = '70'
      }
      // 拼接隐私协议相对路径
      if (this.dataForm.privacyFileUrl && this.dataForm.privacyFileUrl !== '') {
        this.privacyFileUrl = this.dataForm.uploadHost + this.dataForm.privacyFileUrl
      }
      if (this.dataForm.userId === this.userData.userId) {
        this.myselfDisable = true
      } else {
        this.myselfDisable = false
      }
      if (!this.dataForm.headurl || this.dataForm.headurl === '') {
        this.dataForm.headurl = require('@/assets/img/default-image.png')
      }
      // 如果是TA管理员之上
      if (this.roleTypeVal === '0' || this.roleTypeVal === '1') {
        this.TAleaveAndJoinDisabled = false
        this.TAleaveAndJoinOutletDisabled = false
      }
      // 赋值一些变量
      if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
        this.partnter = this.dataForm.orgId
      }
      if (this.dataForm.orgType === ORG_TYPE_BMWG) {
        this.bmwgroup = this.dataForm.orgId
      }
      if (this.dataForm.orgType === ORG_GROUP) {
        this.outGroup = this.dataForm.orgId
      }
      if (this.dataForm.orgType === ORG_OUTLED) {
        this.outletID = this.dataForm.orgId
        if (this.roleTypeVal === '2') {
          this.$request.post('/sys/commuser/commPositionByParam',
            {
              orgType: '60',
              orgId: this.outletID,
              positionName: ''
            }
          ).then((res, total, code, data) => {
            this.positionlist = res
          }).catch((err) => {
            console.log(err)
          })
        }
      }
      // }
      if (this.dataForm.orgType === ORG_SCHOOL) {
        this.perClassification = this.oldperClassification
      }

      // 如果是普通管理员
      if (this.roleTypeVal === '2') {
        this.TAleaveAndJoinDisabled = true
        this.TAleaveAndJoinOutletDisabled = true
        // 组织类型为登录者的组织类型
        console.warn(this.userData)
        this.dataForm.orgType = this.userData.orgType

        if (this.leaveAndJoinFlag === true) {
          if (this.dataForm.orgType === ORG_OUTLED) {
            this.outletID = ''
            this.$request.post('/sys/commuser/queryPartOutlet',
              {
                orgId: this.dataForm.orgId,
                name: ''
              }).then((res, total, code, data) => {
                this.results = res
              }).catch((err) => {
                console.log(err)
              })
            this.TAleaveAndJoinOutletDisabled = false
            this.companyshow = true
            this.partnershow = false
            this.groupshow = false
            this.outGroupShow = false
            this.orgType = ORG_OUTLED
          } else {
            this.$request.get(`/sys/org/selectOrgByParam`, {
              orgId: this.dataForm.orgId,
              orgType: this.dataForm.orgType            }).then((res, total, code, data) => {
              this.companyresults = res
            }).catch((err) => {
              console.log(err)
            })
            // 赋值一些变量
            if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
              this.partnter = this.dataForm.orgId
              this.bmwgroupChange(this.dataForm.orgId, 1)
            }
            if (this.dataForm.orgType === ORG_TYPE_BMWG) {
              this.bmwgroup = this.dataForm.orgId
              this.bmwgroupChange(this.dataForm.orgId, 0)
            }
            if (this.dataForm.orgType === ORG_GROUP) {
              this.outGroup = this.dataForm.orgId
              this.bmwgroupChange(this.dataForm.orgId, 2)
            }
          }
        }
      }
      // 赋值网点类型
      this.dataForm.outletType = Vue.filter('coverEnumList')(this.dataForm.networkType, 'networkType', ',')
      // 算岗龄
      let joinDate = Vue.filter('theTime')(this.dataForm.jobcodeJoinDate)
      if (!this.dataForm.jobcodeJoinDate) {
        joinDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
      }
      let now = Date.parse(new Date(Date.parse(this.sysTime.replace(/-/g, '/'))))
      if (this.dataForm.jobStatus === '20') {
        if (this.dataForm.leaveDate && this.dataForm.leaveDate !== '') {
          now = Vue.filter('theTime')(this.dataForm.leaveDate)
        }
      }
      // 时间差
      let dateDeviation = parseInt(Math.abs(now - joinDate) / 1000 / 60 / 60 / 24, 10)
      this.dataForm.jobcodeAge = dateDeviation
      // 计算宝龄
      let currentVersionDate = 0
      let bmwDateDeviation = 0
      // 如果在职
      if (this.dataForm.jobStatus === '10') {
        if (this.leaveAndJoinFlag !== true) {
          if (this.dataForm.currentVersionDate) {
            currentVersionDate = Vue.filter('theTime')(this.dataForm.currentVersionDate)
            bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
          } else {
            currentVersionDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
            bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
          }
          this.dataForm.bmwSeniority = bmwDateDeviation + this.dataForm.bmwSeniority
        }
      }
      // 历史版本离职日期
      // if (this.dataForm.userHistoryEntityList && this.dataForm.userHistoryEntityList.length > 0) {
      //   this.dataForm.bmwSeniority += this.dataForm.userHistoryEntityList[this.dataForm.userHistoryEntityList.length - 1].bmwSeniority
      // }
      this.dataForm.bmwSeniority = (this.dataForm.bmwSeniority / 365).toFixed(2)
      // 获取角色信息
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.dataForm.userId + ''))
      this.$request.get(
        `/sys/commuser/sysRoleMT`,
        {
          orgType: this.dataForm.orgType,
          authType: this.dataForm.authType,
          id: userId
        }
      ).then((res, total, code, data) => {
        this.rolelist = res.map(item => {
          item.roleId = item.roleId + ''
          return item
        })
        if (_this.dataForm.roleId !== '' && _this.dataForm.roleId !== null && _this.dataForm.roleId !== undefined) {
          if (_this.dataForm.roleId.length > 0) {
            _this.dataForm.roleId = _this.dataForm.roleId.split(',')
            // 手动清空检验，否则角色会直接校验是否为空
            this.$nextTick(function () {
              this.$refs['dataForm'].clearValidate('roleId')
            })
          } else {
            _this.dataForm.roleId = []
          }
        }
      }).catch((err) => {
        console.log(err)
      })
      if (this.dataForm.registrationApprovaStatus) {
        this.dataForm.registrationApprovaStatus = this.dataForm.registrationApprovaStatus + ''
      }
      // 如果是经销商的话，查他的兼职list
      if (this.dataForm.orgType === '60') {
        this.jobCodeContentOne = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.jobCodeContentTwo = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.jobCodeContentThree = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.jobCodeContentFour = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.jobCodeContentFive = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        if (this.dataForm.partTimeJobcodeOne && this.dataForm.partTimeJobcodeOne !== '') {
          // 兼职1网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletOne,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.partResults0 = res
          }).catch((err) => {
            console.log(err)
          })

          // 兼职1职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeOne + ''
            }).then((res, total, code, data) => {
              this.parttimejobList0 = res
              this.jobCodeNumOne = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent') + '<br/>' + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
        }
        if (this.dataForm.partTimeJobcodeTwo && this.dataForm.partTimeJobcodeTwo !== '') {
          // 兼职2网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletTwo,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.partResults1 = res
          }).catch((err) => {
            console.log(err)
          })

          // 兼职2职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeTwo + ''
            }).then((res, total, code, data) => {
              this.parttimejobList1 = res
              this.jobCodeNumTwo = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
        }
        if (this.dataForm.partTimeJobcodeThree && this.dataForm.partTimeJobcodeThree !== '') {
          // 兼职3网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletThree,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.partResults2 = res
          }).catch((err) => {
            console.log(err)
          })

          // 兼职3职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeThree + ''
            }).then((res, total, code, data) => {
              this.parttimejobList2 = res
              this.jobCodeNumThree = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
        }
        if (this.dataForm.partTimeJobcodeFour && this.dataForm.partTimeJobcodeFour !== '') {
          // 兼职4网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletFour,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.partResults3 = res
          }).catch((err) => {
            console.log(err)
          })

          // 兼职4职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeFour + ''
            }).then((res, total, code, data) => {
              this.parttimejobList3 = res
              this.jobCodeNumFour = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
        }
        if (this.dataForm.partTimeJobcodeFive && this.dataForm.partTimeJobcodeFive !== '') {
          // 兼职5网点回显
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.dataForm.partTimeOutletFive,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.partResults4 = res
          }).catch((err) => {
            console.log(err)
          })

          // 兼职5职位回显
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.dataForm.partTimeJobcodeFive + ''
            }).then((res, total, code, data) => {
              this.parttimejobList4 = res
              this.jobCodeNumFive = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
        }
        if (this.dataForm.partTimeJobcodeOne !== '' && this.dataForm.partTimeJobcodeOne !== null && this.dataForm.partTimeJobcodeOne !== undefined) {
          this.partTimejobCodeOneshow = true
          this.partTimeJobCodeContentChange(this.dataForm.partTimeJobcodeOne, 'One', 0)
        }
        if (this.dataForm.partTimeJobcodeTwo !== '' && this.dataForm.partTimeJobcodeTwo !== null && this.dataForm.partTimeJobcodeTwo !== undefined) {
          this.partTimejobCodeTwoshow = true
          this.partTimeJobCodeContentChange(this.dataForm.partTimeJobcodeTwo, 'Two', 1)
        }
        if (this.dataForm.partTimeJobcodeThree !== '' && this.dataForm.partTimeJobcodeThree !== null && this.dataForm.partTimeJobcodeThree !== undefined) {
          this.partTimejobCodeThreeshow = true
          this.partTimeJobCodeContentChange(this.dataForm.partTimeJobcodeThree, 'Three', 2)
        }
        if (this.dataForm.partTimeJobcodeFour !== '' && this.dataForm.partTimeJobcodeFour !== null && this.dataForm.partTimeJobcodeFour !== undefined) {
          this.partTimejobCodeFourshow = true
          this.partTimeJobCodeContentChange(this.dataForm.partTimeJobcodeFour, 'Four', 3)
        }
        if (this.dataForm.partTimeJobcodeFive !== '' && this.dataForm.partTimeJobcodeFive !== null && this.dataForm.partTimeJobcodeFive !== undefined) {
          this.partTimejobCodeFiveshow = true
          this.partTimeJobCodeContentChange(this.dataForm.partTimeJobcodeFive, 'Five', 4)
        }
      }
      if (this.dataForm.orgId) {
        this.$request.get('/sys/org/queryOrgForUserViewAndEdit',
          {
            orgId: this.dataForm.orgId,
            orgType: this.dataForm.orgType
          }
        ).then((res, total, code, data) => {
          // 经销商时需要回显品牌
          if (this.dataForm.orgType === '60') {
            var brandCodes = res[0].brandCodes
            this.dataForm.brandCode = Vue.filter('coverEnumList')(brandCodes, 'brandCode', ',')
            this.results = res
          } else {
            this.companyresults = res
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      if (this.dataForm.orgId !== '' && this.dataForm.jobCode !== '') {
        // 根据jobCode回显主职
        this.$request.get(`/sys/commuser/selectPositionByCode`,
          {
            positionCode: this.dataForm.jobCode + ''
          }
        ).then((res, total, code, data) => {
          this.positionlist = res
          if (this.dataForm.jobCode === '' || this.dataForm.jobCode === undefined || this.dataForm.jobCode === null) {
            this.jobCodeNum = this.$t('activiti.jobCodeNum')
            this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
          } else {
            this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
            if (res[0].positionDesc) {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
            }
            console.warn(this.jobCodeContent)
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      // 初始时记录加入公司日期
      this.orgJoinDate = this.dataForm.orgJoinDate
      if (this.dataForm.dealerShipId) {
        this.dataForm.dealerShipId = this.dataForm.dealerShipId + ''
        if (this.dataForm.dealerShipId === 'null') {
          this.dataForm.dealerShipId = ''
        }
      }

      this.historydataForm = data.userHistoryEntityList
      if (this.dataForm.orgType === ORG_PARTANER) {
        this.partnerJobCode = true
      } else {
        this.partnerJobCode = false
      }
      if (this.dataForm.orgType === ORG_SCHOOL) {
      }
      if (this.dataForm.orgType === ORG_TYPE_BMWG) {
        this.groupshow = true
        this.outGroupShow = false
        this.partnershow = false
        this.companyshow = false
        this.orgType = ORG_TYPE_BMWG
      }
      if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
        this.groupshow = false
        this.partnershow = true
        this.outGroupShow = false
        this.companyshow = false
        this.orgType = this.dataForm.orgType
      }
      if (this.dataForm.orgType === ORG_OUTLED) {
        this.companyshow = true
        this.partnershow = false
        this.groupshow = false
        this.outGroupShow = false
        this.orgType = ORG_OUTLED
      }
      if (this.dataForm.orgType === ORG_GROUP) {
        this.companyshow = false
        this.partnershow = false
        this.groupshow = false
        this.outGroupShow = true
        this.orgType = ORG_GROUP
      }
      if (this.dataForm.jobStatus === '10') {
        this.accessionDateshow = true
        this.leavedateshow = false
        this.dataForm.leaveDate = ''
        this.joincompny = this.dataForm.orgJoinDate
        this.jianzhiorgJoinDate = this.dataForm.orgJoinDate
      } else if (this.dataForm.jobStatus === '20') {
        this.leavedateshow = true
        this.accessionDateshow = true
        if (!this.dataForm.userId || this.dataForm.userId === '') {
          this.dataForm.orgJoinDate = ''
        }
        this.leaveCompany = this.dataForm.leaveDate
      }
      if (this.dataForm.authType === AUTHTYPE_BESTSTUDENT && this.orgType === ORG_SCHOOL) {
        this.studentshow = true
        this.teachershow = false
      } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_SCHOOL) {
        this.studentshow = false
        // this.teachershow = true
        this.teachershow = false
        this.teacherjobCode = this.dataForm.jobCode
        this.teacherjobCodeJoinDate = this.dataForm.jobcodeJoinDate
        this.teacherjobCodeLeaveDate = this.dataForm.jobcodeLeaveDate
      } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_TYPE_BMWG) {
        this.studentshow = false
        // this.teachershow = true
        this.teachershow = false
        this.teacherjobCode = this.dataForm.jobCode
        this.teacherjobCodeJoinDate = this.dataForm.jobcodeJoinDate
        this.teacherjobCodeLeaveDate = this.dataForm.jobcodeLeaveDate
      } else if (this.dataForm.authType === AUTHTYPE_TEACHER && this.orgType === ORG_PARTANER) {
        this.studentshow = false
        // this.teachershow = true
        this.teachershow = false
        this.teacherjobCode = this.dataForm.jobCode
        this.teacherjobCodeJoinDate = this.dataForm.jobcodeJoinDate
        this.teacherjobCodeLeaveDate = this.dataForm.jobcodeLeaveDate
      } else if (this.dataForm.authType === AUTHTYPE_USER && this.orgType === ORG_PARTANER) {
        this.studentshow = false
        this.teachershow = false
      } else if (this.dataForm.authType === AUTHTYPE_LAYER) {
        this.studentshow = false
        this.teachershow = false
      } else if (this.dataForm.authType === AUTHTYPE_ADMIN) {
        this.studentshow = false
        this.teachershow = false
      }
      if (this.leaveAndJoinFlag === true) {
        this.dataForm.authType = ''
      }
      this.activeName2 = 'first'
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    // 获取信息
    getInfo() {
      // const base64url = require('base64-url')
      // let aes = new AesUtil()
      // let userId = base64url.encode(aes.encrypt(this.dataForm.userId + ''))

      this.$request.get(`/sys/commuser/infomt/${this.dataForm.userId}`).then((res, total, code, data) => {
        this.initData(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    back() {
      this.$router.push({
        name: 'sys-user'
      })
    },
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: 'sys-user'
        })
      }
    },
    initialization() {
      // 初始时，按钮设置可用
      this.isDisable = false
      this.jobStatusDisable = false
      this.jobCodeshow = false

      this.leaveAndJoinFlag = false
      this.leaveAndJoinDisabled = false
      // 兼职网点显示
      this.partOrgShow = true
      const messagesConst = messages[VueI18n.locale]

      this.newperClassification = JSON.parse(JSON.stringify(this.perClassification))
      for (let index in this.newperClassification) {
        if (this.newperClassification[index].code + '' === '50') {
          this.newperClassification.splice(index, 1)
        }
      }
      // this.oldperClassification = JSON.parse(JSON.stringify(this.perClassification))
      this.oldperClassification = JSON.parse(JSON.stringify(this.newperClassification))
      this.perClassification = this.newperClassification
      // // 删除组织类型第四第五元素
      this.neworgType = JSON.parse(JSON.stringify(this.userorgType))
      if (this.neworgType.length === 6) {
        // this.neworgType.splice(3, 2)
        this.neworgType.splice(4, 1)
        console.warn(this.dataForm.userId)
        if (this.$route.query.userId && this.$route.query.userId !== '') {
          // this.neworgType.splice(0, 1)
        } else {
          this.neworgType.splice(0, 1)
        }
      }
      // 获取用户id
      if (this.$route.query.userId !== undefined && this.$route.query.userId !== null && this.$route.query.userId !== '') {
        this.dataForm.userId = this.$route.query.userId
        this.leaveFlag = false
        console.log(this.$route.query.jobStatus)
        if (this.$route.query.jobStatus && this.$route.query.jobStatus === '20') {
          this.leaveFlag = true
        }
        // 修改
        this.jobabled = false
        this.jobCodeshow = false
        this.select = ''
        this.jobStatusDisable = true
        this.joindateabled = true
        this.studentshow = false
        this.teachershow = false
        this.groupshow = false
        this.outGroupShow = false
        this.partnershow = false
        this.companyshow = false
        this.editDisable = true
        this.outletIDshow = true

        this.headModifyShow = true
        this.headDateShow = true
        this.canEdit = true
        this.getInfo()
      } else {
        this.headDateShow = false
        this.headModifyShow = false
        this.joindateabled = false
        this.select = messagesConst.user.s
        // 新增
        this.jobabled = true
        this.leavedateshow = false
        this.studentshow = false
        this.teachershow = false
        this.groupshow = false
        this.outGroupShow = false
        this.partnershow = false
        this.companyshow = false
        this.rolelist = ''
        this.jobCodeNum = this.$t('activiti.jobCodeNum')
        this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
        this.jobStatusDisable = true
        this.positionlist = []
        this.parttimejoblist0 = []
        this.parttimejoblist1 = []
        this.parttimejoblist2 = []
        this.parttimejoblist3 = []
        this.parttimejoblist4 = []
        this.editDisable = false
        this.outletIDshow = false
        this.canEdit = false
        // 获取预留经销商
        this.$request.get('/sys/org/selectOrg',
          {
            orgType: '50'
          }
        ).then((res, total, code, data) => {
          this.orgResulets = res.map(item => {
            item.orgId = item.orgId + ''
            return item
          })
        }).catch((err) => {
          console.log(err)
        })
        // 如果是TA管理员之上
        if (this.roleTypeVal === '0' || this.roleTypeVal === '1') {
          this.TAleaveAndJoinDisabled = false
          this.TAleaveAndJoinOutletDisabled = false
        }
        // this.roleTypeVal = '2'
        console.warn(this.roleTypeVal)
        // 如果是普通管理员
        if (this.roleTypeVal === '2') {
          console.warn('ininin')
          this.TAleaveAndJoinDisabled = true
          this.TAleaveAndJoinOutletDisabled = true
          // 组织类型为登录者的组织类型
          this.dataForm.orgType = this.userData.orgType
          this.dataForm.orgId = this.userData.orgId

          // 赋值一些变量
          if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
            this.partnter = this.dataForm.orgId
            this.bmwgroupChange(this.dataForm.orgId, 1)
          }
          if (this.dataForm.orgType === ORG_TYPE_BMWG) {
            this.bmwgroup = this.dataForm.orgId
            this.bmwgroupChange(this.dataForm.orgId, 0)
          }
          if (this.dataForm.orgType === ORG_GROUP) {
            this.outGroup = this.dataForm.orgId
            this.bmwgroupChange(this.dataForm.orgId, 2)
          }
          if (this.dataForm.orgType === ORG_SCHOOL) {
            this.perClassification = this.oldperClassification
          }
          if (this.dataForm.orgType === ORG_OUTLED) {
            this.outletID = ''
            this.$request.post('/sys/commuser/queryPartOutlet',
              {
                orgId: this.dataForm.orgId,
                name: ''
              }).then((res, total, code, data) => {
                this.results = res
              }).catch((err) => {
                console.log(err)
              })
            this.TAleaveAndJoinOutletDisabled = false
            this.companyshow = true
            this.partnershow = false
            this.groupshow = false
            this.orgType = ORG_OUTLED
          } else {
            this.$request.get(`/sys/org/selectOrgByParam`, {
              orgId: this.dataForm.orgId,
              orgType: this.dataForm.orgType
            }).then((res, total, code, data) => {
              this.companyresults = res
            }).catch((err) => {
              console.log(err)
            })
          }
          this.studentshow = false
          this.teachershow = false
          if (this.dataForm.orgType === ORG_TYPE_BMWG) {
            this.groupshow = true
            this.partnershow = false
            this.companyshow = false
            this.outGroupShow = false
            this.orgType = ORG_TYPE_BMWG
          }
          if (this.dataForm.orgType === ORG_PARTANER || this.dataForm.orgType === ORG_SCHOOL) {
            this.groupshow = false
            this.partnershow = true
            this.outGroupShow = false
            this.companyshow = false
            this.orgType = this.dataForm.orgType
          }
          this.studentshow = false
          if (this.dataForm.authType === AUTHTYPE_BESTSTUDENT && this.orgType === ORG_SCHOOL) {
            this.studentshow = true
          }
          if (this.dataForm.orgType === ORG_GROUP) {
            this.groupshow = false
            this.partnershow = false
            this.outGroupShow = true
            this.companyshow = false
          }
        }
      }
      // 获取系统时间
      this.$request.get('/sys/commuser/sysDate',
      ).then((res, total, code, data) => {
        // this.sysTime = new Date(res.sysTime)
        this.sysTime = res.sysTime
      }).catch((err) => {
        console.log(err)
      })
      // 监听input控件，补title
      $('.el-form-item__label').hover(function (e) {
        e.target.title = e.target.innerText
      })
    },
    // 变更兼职职位描述
    partTimeJobCodeContentChange(el, key, num) {
      if (el === '' || el === undefined || el === null) {
        this['jobCodeNum' + key] = this.$t('activiti.jobCodeNum')
        this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent')
      } else {
        let parttimejobList = this['parttimejobList' + num]
        for (let i = 0; i < parttimejobList.length; i++) {
          if (el === parttimejobList[i].positionCode) {
            this['jobCodeNum' + key] = this.$t('activiti.jobCodeNum') + parttimejobList[i].positionCode
            if (parttimejobList[i].positionDesc) {
              this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent') + parttimejobList[i].positionDesc
            } else {
              this['jobCodeContent' + key] = this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    historypartTimeJobCodeContentChange(el, key, num) {
      if (el === '' || el === undefined || el === null) {
        this['historyjobCodeNum' + key] = this.$t('activiti.jobCodeNum')
        this['historyjobCodeContent' + key] = this.$t('activiti.jobCodeContent')
      } else {
        for (let i = 0; i < this.historyparttimejoblist.length; i++) {
          if (el === this.historyparttimejoblist[i].positionCode) {
            this['historyjobCodeNum' + key] = this.$t('activiti.jobCodeNum') + this.historyparttimejoblist[i].positionCode
            if (this.historyparttimejoblist[i].positionDesc) {
              this['historyjobCodeContent' + key] = this.$t('activiti.jobCodeContent') + this.historyparttimejoblist[i].positionDesc
            } else {
              this['historyjobCodeContent' + key] = this.$t('activiti.jobCodeContent')
            }
          }
        }
      }
    },
    handlePreview(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      console.log(file)
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      //  this.fileList = []
      if (response.code !== 1) {
        this.$message({
          message: response.msg,
          type: 'error',
          duration: 1500,
        })
      } else {
        this.$message({
          message: '上传成功',
          type: 'success',
          duration: 1500,
        })
      }
      this.dataForm.fileManagementId = response.data.fileManagementId
      this.dataForm.fileContent = response.data.fileName
      this.dataForm.filePath = response.data.filePath
      this.$forceUpdate()
    },
    beforeExcelUpload(file, fileList) {
      if (file == null) {
        this.$message({
          message: '请先上传文件',
          type: 'error',
          duration: 1500,
          // onClose: () => {
          //     this.getDataList()
          // }
        })
        return false
      }
      let maxLength = 20 * 1024 * 1024
      if (file.size > maxLength) {
        this.$message({
          message: '文件大小不能超过20M',
          type: 'error',
          duration: 1500,
        })
        return false
      }
      let fullName = file.name
      let idx = fullName.lastIndexOf(".")
      let extName = fullName.substr(idx + 1);
      extName = extName.toUpperCase()
      let includeExt = new Array('PDF','JPG','JPEG','PNG','BMP') // ('PDF','JPG','JPEG','PNG','PBG','GIF','BMP')
      if (includeExt.indexOf(extName) < 0) {
        this.$message({
          message: this.$t('authApply.fileFormatMsg'),  // '请上传PDF格式或图片格式文件',
          type: 'error',
          duration: 1500,
        })
        return false
      }
      return true
    },
    changeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    downloadFile() {
      if (this.dataForm.fileContent === '' || this.dataForm.fileContent === null || this.dataForm.fileContent === undefined) {
        this.$message({
          message: '请先上传文件',
          type: 'error',
          duration: 1500,
        })
      } else {
        this.$message({
          message: this.$t('user.authApplyDownloadFileMessage'),
          type: 'info',
          duration: 1000,
        })
        this.$request.downloadBigFile('/sys/commAdminFileManagement/downloadUploadedFile',
        // this.$request.download('/sys/commAdminFileManagement/downloadFile',
          this.dataForm.fileContent,
          {
            fileManagementId: this.dataForm.fileManagementId
          },
          null,
          true
        )
      }
    },
    downloadTemplate() {
      this.$request.download('/sys/commAdminFileManagement/downloadTemplate',
        this.dataForm.templeteFileName, // '管理员资质模板.xlsx',
        {

        },
        null,
        true
      )
    },
  },

  mounted() {
    // 获取用户的信息和身份
    this.userData = this.getStorage(this.GLOBAL.USER_DATA)
    this.roleTypeVal = this.userData.roleTypeVal
    this.initialization()
    //this.myData = { userId: this.dataForm.userId, type: '10', formal: '20', orgType: this.dataForm.orgType }
  },
  created() {
    // this.uploadUrl = `${window.SITE_CONFIG['apiURL']}${this.url}?token=${this.getStorage(this.GLOBAL.TOKEN)}`
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_USER, (data) => {
      this.parttimeShow0 = true
      this.parttimeShow1 = true
      this.parttimeShow2 = true
      this.parttimeShow3 = true
      this.parttimeShow4 = true
      this.partOrgShow = true
      this.headModifyShow = false
      this.activeName2 = 'first'
      this.privacyFileUrl = ''
      this.privacyFileUrlHistory = ''
      this.myselfDisable = false
      this.leaveFlag = false
      // 获取用户的信息和身份
      this.userData = this.getStorage(this.GLOBAL.USER_DATA)
      console.warn(this.userData)
      this.roleTypeVal = this.userData.roleTypeVal
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields()
        this.dataForm = {
          idType: '10',
          headurl: require('@/assets/img/default-image.png'),
          idcard: '',
          agreePolicy: '10',
          userId: '',
          userCardNo: '',
          roleId: [],
          jobCode: '',
          jobcodeJoinDate: '',
          passwordUpdateTime: '',
          jobcodeLeaveDate: '',
          partTimeJobcodeOne: '',
          partTimeJobcodeTwo: '',
          partTimeOutletOne: '',
          partTimeOutletTwo: '',
          partTimeJobcodeThree: '',
          partTimeJobcodeFour: '',
          jobcodeJoinDateOne: '',
          jobcodeJoinDateTwo: '',
          jobcodeJoinDateThree: '',
          jobcodeJoinDateFour: '',
          jobcodeLeaveDateTwo: '',
          jobcodeLeaveDateThree: '',
          jobcodeLeaveDateFour: '',
          jobcodeLeaveDateOne: '',
          birthday: '',
          sexCode: '',
          leaveDate: '',
          orgJoinDate: '',
          loginFlag: '10',
          brandCode: '',
          jobStatus: '10',
          enterSchoolDate: '',
          leaveSchoolDate: '',
          orgType: '',
          authType: '',
          deactivatedReason: ''
        }
        this.bmwgroup = ''
        this.outGroup = ''
        this.outletID = ''
        this.partTimejobCodeOneshow = false
        this.partTimejobCodeTwoshow = false
        this.partTimejobCodeThreeshow = false
        this.partTimejobCodeFourshow = false
        this.partTimejobCodeFiveshow = false
        this.historydataForm = {}
        this.initialization()
      }
    })
    this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url
    this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
    // const base64url = require('base64-url')
    // let aes = new AesUtil()
    // let userId = base64url.encode(aes.encrypt(this.dataForm.userId + ''))
    this.myData = { userId: this.dataForm.userId, type: '10', formal: '20', orgType: this.dataForm.orgType }
    this.$request.get(`/sys/config/acquireOrgTypeSetting`).then((res, total, code, data) => {
      this.dataMap = new Map()
      for (let i = 0; i < res.length; i++) {
        this.dataMap.set(res[i].paramKey, res[i].paramValue)
      }
    }).catch((err) => {
      console.log(err)
    })
    // 取得资质文件模板名称
    this.$request.get(`/sys/commAdminFileManagement/getTempleteFileName`,
        {
            paramKey: 'ADMIN_LEVEL_TEMPLETE_FILE'
        }
    ).then((res, total, code, data) => {
        console.info('模板文件名称' + res)
        this.dataForm.templeteFileName = res
    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>

<style lang="scss" scoped>
li {
  list-style: none;
}
.btn-mar-t {
  margin-top: 20px;
}
.opten-title {
  margin-top: 20px;
}
.addbutton {
  background-color: white;
  border: none;
}
.img-div {
  text-align: center;
  width: 142px;
  margin-left: 7%;
  img {
    width: 100%;
    min-height: 100px;
  }
  .modify-img {
    cursor: pointer;
    margin-top: 10px;
  }
}
.upload-demo {
  display: inline-block;
}
.redText {
  margin: 5px;
  color: red;
  display: inline-block;
}
.inline {
  display: inline-block;
}
.headDate {
  height: 30px;
  background: #5c9df5;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.custom {
  opacity: 1;
  -webkit-text-fill-color: #5c9df5;
  cursor: hand;
 // font-size:0;

}
.fl-input.is-disabled  .el-input__inner {
  color: blue !important;
  text-decoration:underline;
  cursor:pointer;
}
</style>
<style lang="scss">
.user-transfer-islimit-modal {
  border-radius: 4px !important;
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  .el-dialog__header{
    padding: 15px 15px 10px;
  }
  .el-dialog__body {
    padding: 0 !important;
    color: #606266;
    font-size: 14px;
    overflow: hidden;
  }
}
</style>
